(function mdvSearchV2Controller(root, factory) {
  'use strict';
  var exported = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = exported;
  else if (root) root.MDVSearchV2Render = exported;
}(typeof globalThis !== 'undefined' ? globalThis : this, function mdvSearchV2Factory(root) {
  'use strict';

  var FACET_ORDER = ['gender', 'category', 'size', 'colour', 'fit', 'material', 'price', 'availability', 'sale'];
  var SEARCH_GENDER_ORDER = ['woman', 'man', 'unisex'];
  var SEARCH_SORTS = ['relevance', 'price-asc', 'price-desc'];
  var PRICE_DERIVED_FACETS = ['price', 'sale'];
  var RECENT_LIMIT = 3;
  // Under two characters Stage 2 browses velocity-ranked best sellers instead
  // of query results. `best` feeds the grid (the Worker's `featured` sort on a
  // collection falls through to seven-day sales velocity); `catalog` supplies
  // the gender facet's full-catalogue count. Handles verified live on all six
  // stores. There is no populated all-gender or unisex best-seller collection,
  // so an unpicked gender merges the women's and men's lists.
  // Real searching starts at three characters, so genuine short product words
  // ("cap", "bag", "top") still search while one- and two-letter fragments
  // show best sellers instead of a near-meaningless result set.
  var SEARCH_MIN_QUERY = 3;
  var BROWSE_LIMIT = 24;
  var BROWSE_LABEL = 'Best Sellers';
  var BROWSE_CATALOGUES = Object.freeze({ woman: 'womens-view-all', man: 'mens-view-all', unisex: 'womens-unisex' });
  var BROWSE_SOURCES = Object.freeze({
    woman: Object.freeze({ best: ['womens-best-sellers'], catalog: ['womens-view-all'] }),
    man: Object.freeze({ best: ['mens-best-sellers'], catalog: ['mens-view-all'] }),
    unisex: Object.freeze({ best: ['womens-unisex'], catalog: ['womens-unisex'] }),
    all: Object.freeze({ best: ['womens-best-sellers', 'mens-best-sellers'], catalog: ['womens-view-all', 'mens-view-all'] }),
  });
  // Singular by house style, and applied to every gender facet the UI renders
  // (rail, drawer and chips) so the Worker's own plural labels can't leak back in.
  var GENDER_LABELS = Object.freeze({ woman: 'Woman', man: 'Man', unisex: 'Unisex' });
  var POPULAR_COLLECTION_SLOTS = Object.freeze([
    Object.freeze({ handle: 'womens-new-in', aliases: ['womens-new-in', 'women-new-in'], titleKey: 'womensNewIn', url: '/collections/womens-new-in' }),
    Object.freeze({ handle: 'mens-new-in', aliases: ['mens-new-in', 'men-new-in'], titleKey: 'mensNewIn', url: '/collections/mens-new-in' }),
    Object.freeze({ handle: 'womens-best-sellers', aliases: ['womens-best-sellers', 'best-sellers'], titleKey: 'bestSellers', url: '/collections/womens-best-sellers' }),
    Object.freeze({ handle: 'womens-unisex', aliases: ['womens-unisex', 'unisex'], titleKey: 'unisex', url: '/collections/womens-unisex' }),
  ]);
  var UI_COPY = {
    en: {
      search: 'Search', searchResults: 'Search results', closeSearch: 'Close search', recent: 'Recent searches', clear: 'Clear', trending: 'Trending searches', popular: 'Popular collections', suggestions: 'Search suggestions', collections: 'Collections', filters: 'Filters', sort: 'Sort by', featured: 'Featured', priceAsc: 'Price: low to high', priceDesc: 'Price: high to low', loading: 'Loading products', closeFilters: 'Close filters', clearAll: 'Clear all', viewResults: 'View {count} results', noRecent: 'No recent searches', resultOne: 'result', resultOther: 'results', forQuery: 'for', correctedFrom: 'Corrected from “{query}”', unavailable: 'Search is temporarily unavailable. Please try again.', noProducts: 'No products found for “{query}”.', viewMore: 'View more', filtersUnavailable: 'Filters are temporarily unavailable.', removeFilter: 'Remove {label} filter', availableColours: 'Available colours', viewColour: 'View {colour}', inColour: 'in', newIn: 'New in', tailoring: 'Tailoring', suedeJackets: 'Suede jackets', coOrds: 'Co-ords', womensNewIn: "Women's new in", mensNewIn: "Men's new in", bestSellers: 'Best sellers', unisex: 'Unisex', addWishlist: 'Add to wishlist', loadMore: 'Load more', of: 'of', filtersSelected: '{count} filters selected', noFilters: 'No filters selected', clearFilters: 'Clear filters', viewItems: 'View {count} items'
    },
    fr: {
      search: 'Rechercher', searchResults: 'Résultats de recherche', closeSearch: 'Fermer la recherche', recent: 'Recherches récentes', clear: 'Effacer', trending: 'Recherches tendance', popular: 'Collections populaires', suggestions: 'Suggestions de recherche', collections: 'Collections', filters: 'Filtres', sort: 'Trier par', featured: 'En vedette', priceAsc: 'Prix croissant', priceDesc: 'Prix décroissant', loading: 'Chargement des produits', closeFilters: 'Fermer les filtres', clearAll: 'Tout effacer', viewResults: 'Voir {count} résultats', noRecent: 'Aucune recherche récente', resultOne: 'résultat', resultOther: 'résultats', forQuery: 'pour', correctedFrom: 'Corrigé depuis « {query} »', unavailable: 'La recherche est temporairement indisponible. Veuillez réessayer.', noProducts: 'Aucun produit trouvé pour « {query} ».', viewMore: 'Voir plus', filtersUnavailable: 'Les filtres sont temporairement indisponibles.', removeFilter: 'Supprimer le filtre {label}', availableColours: 'Couleurs disponibles', viewColour: 'Voir {colour}', inColour: 'en', newIn: 'Nouveautés', tailoring: 'Tailoring', suedeJackets: 'Vestes en daim', coOrds: 'Ensembles', womensNewIn: 'Nouveautés femme', mensNewIn: 'Nouveautés homme', bestSellers: 'Meilleures ventes', unisex: 'Unisexe', addWishlist: 'Ajouter à la liste de souhaits', loadMore: 'Charger plus', of: 'sur', filtersSelected: '{count} filtres sélectionnés', noFilters: 'Aucun filtre sélectionné', clearFilters: 'Effacer les filtres', viewItems: 'Voir {count} articles'
    },
    de: {
      search: 'Suchen', searchResults: 'Suchergebnisse', closeSearch: 'Suche schließen', recent: 'Letzte Suchanfragen', clear: 'Löschen', trending: 'Beliebte Suchanfragen', popular: 'Beliebte Kollektionen', suggestions: 'Suchvorschläge', collections: 'Kollektionen', filters: 'Filter', sort: 'Sortieren nach', featured: 'Empfohlen', priceAsc: 'Preis: niedrig bis hoch', priceDesc: 'Preis: hoch bis niedrig', loading: 'Produkte werden geladen', closeFilters: 'Filter schließen', clearAll: 'Alle löschen', viewResults: '{count} Ergebnisse anzeigen', noRecent: 'Keine letzten Suchanfragen', resultOne: 'Ergebnis', resultOther: 'Ergebnisse', forQuery: 'für', correctedFrom: 'Korrigiert von „{query}“', unavailable: 'Die Suche ist vorübergehend nicht verfügbar. Bitte erneut versuchen.', noProducts: 'Keine Produkte für „{query}“ gefunden.', viewMore: 'Mehr anzeigen', filtersUnavailable: 'Filter sind vorübergehend nicht verfügbar.', removeFilter: 'Filter {label} entfernen', availableColours: 'Verfügbare Farben', viewColour: '{colour} anzeigen', inColour: 'in', newIn: 'Neuheiten', tailoring: 'Schneiderei', suedeJackets: 'Wildlederjacken', coOrds: 'Sets', womensNewIn: 'Damen Neuheiten', mensNewIn: 'Herren Neuheiten', bestSellers: 'Bestseller', unisex: 'Unisex', addWishlist: 'Zur Wunschliste hinzufügen', loadMore: 'Mehr laden', of: 'von', filtersSelected: '{count} Filter ausgewählt', noFilters: 'Keine Filter ausgewählt', clearFilters: 'Filter löschen', viewItems: '{count} Artikel anzeigen'
    },
    nl: {
      search: 'Zoeken', searchResults: 'Zoekresultaten', closeSearch: 'Zoeken sluiten', recent: 'Recente zoekopdrachten', clear: 'Wissen', trending: 'Populaire zoekopdrachten', popular: 'Populaire collecties', suggestions: 'Zoeksuggesties', collections: 'Collecties', filters: 'Filters', sort: 'Sorteren op', featured: 'Uitgelicht', priceAsc: 'Prijs: laag naar hoog', priceDesc: 'Prijs: hoog naar laag', loading: 'Producten laden', closeFilters: 'Filters sluiten', clearAll: 'Alles wissen', viewResults: '{count} resultaten bekijken', noRecent: 'Geen recente zoekopdrachten', resultOne: 'resultaat', resultOther: 'resultaten', forQuery: 'voor', correctedFrom: 'Gecorrigeerd van “{query}”', unavailable: 'Zoeken is tijdelijk niet beschikbaar. Probeer het opnieuw.', noProducts: 'Geen producten gevonden voor “{query}”.', viewMore: 'Meer bekijken', filtersUnavailable: 'Filters zijn tijdelijk niet beschikbaar.', removeFilter: 'Filter {label} verwijderen', availableColours: 'Beschikbare kleuren', viewColour: 'Bekijk {colour}', inColour: 'in', newIn: 'Nieuw binnen', tailoring: 'Tailoring', suedeJackets: 'Suède jassen', coOrds: 'Sets', womensNewIn: 'Dames nieuw binnen', mensNewIn: 'Heren nieuw binnen', bestSellers: 'Bestsellers', unisex: 'Unisex', addWishlist: 'Toevoegen aan verlanglijst', loadMore: 'Meer laden', of: 'van', filtersSelected: '{count} filters geselecteerd', noFilters: 'Geen filters geselecteerd', clearFilters: 'Filters wissen', viewItems: '{count} items bekijken'
    },
    it: {
      search: 'Cerca', searchResults: 'Risultati di ricerca', closeSearch: 'Chiudi ricerca', recent: 'Ricerche recenti', clear: 'Cancella', trending: 'Ricerche di tendenza', popular: 'Collezioni popolari', suggestions: 'Suggerimenti di ricerca', collections: 'Collezioni', filters: 'Filtri', sort: 'Ordina per', featured: 'In evidenza', priceAsc: 'Prezzo: dal più basso', priceDesc: 'Prezzo: dal più alto', loading: 'Caricamento prodotti', closeFilters: 'Chiudi filtri', clearAll: 'Cancella tutto', viewResults: 'Vedi {count} risultati', noRecent: 'Nessuna ricerca recente', resultOne: 'risultato', resultOther: 'risultati', forQuery: 'per', correctedFrom: 'Corretto da “{query}”', unavailable: 'La ricerca non è temporaneamente disponibile. Riprova.', noProducts: 'Nessun prodotto trovato per “{query}”.', viewMore: 'Mostra altro', filtersUnavailable: 'I filtri non sono temporaneamente disponibili.', removeFilter: 'Rimuovi filtro {label}', availableColours: 'Colori disponibili', viewColour: 'Vedi {colour}', inColour: 'in', newIn: 'Novità', tailoring: 'Sartoria', suedeJackets: 'Giacche in camoscio', coOrds: 'Completi coordinati', womensNewIn: 'Novità donna', mensNewIn: 'Novità uomo', bestSellers: 'Più venduti', unisex: 'Unisex', addWishlist: 'Aggiungi alla lista desideri', loadMore: 'Carica altro', of: 'di', filtersSelected: '{count} filtri selezionati', noFilters: 'Nessun filtro selezionato', clearFilters: 'Cancella filtri', viewItems: 'Vedi {count} articoli'
    },
    ar: {
      search: 'بحث', searchResults: 'نتائج البحث', closeSearch: 'إغلاق البحث', recent: 'عمليات البحث الأخيرة', clear: 'مسح', trending: 'عمليات البحث الرائجة', popular: 'المجموعات الشائعة', suggestions: 'اقتراحات البحث', collections: 'المجموعات', filters: 'عوامل التصفية', sort: 'الترتيب حسب', featured: 'مميز', priceAsc: 'السعر: من الأقل إلى الأعلى', priceDesc: 'السعر: من الأعلى إلى الأقل', loading: 'جارٍ تحميل المنتجات', closeFilters: 'إغلاق عوامل التصفية', clearAll: 'مسح الكل', viewResults: 'عرض {count} نتيجة', noRecent: 'لا توجد عمليات بحث أخيرة', resultOne: 'نتيجة', resultOther: 'نتائج', forQuery: 'عن', correctedFrom: 'تم التصحيح من ”{query}“', unavailable: 'البحث غير متاح مؤقتًا. يرجى المحاولة مرة أخرى.', noProducts: 'لم يتم العثور على منتجات لـ ”{query}“.', viewMore: 'عرض المزيد', filtersUnavailable: 'عوامل التصفية غير متاحة مؤقتًا.', removeFilter: 'إزالة عامل التصفية {label}', availableColours: 'الألوان المتاحة', viewColour: 'عرض {colour}', inColour: 'باللون', newIn: 'وصل حديثًا', tailoring: 'التفصيل', suedeJackets: 'سترات شمواه', coOrds: 'أطقم متناسقة', womensNewIn: 'وصل حديثًا للنساء', mensNewIn: 'وصل حديثًا للرجال', bestSellers: 'الأكثر مبيعًا', unisex: 'للجنسين', addWishlist: 'إضافة إلى قائمة الرغبات', loadMore: 'تحميل المزيد', of: 'من', filtersSelected: 'تم تحديد {count} من عوامل التصفية', noFilters: 'لم يتم تحديد عوامل تصفية', clearFilters: 'مسح عوامل التصفية', viewItems: 'عرض {count} منتج'
    },
    da: {
      search: 'Søg', searchResults: 'Søgeresultater', closeSearch: 'Luk søgning', recent: 'Seneste søgninger', clear: 'Ryd', trending: 'Populære søgninger', popular: 'Populære kollektioner', suggestions: 'Søgeforslag', collections: 'Kollektioner', filters: 'Filtre', sort: 'Sortér efter', featured: 'Fremhævet', priceAsc: 'Pris: lav til høj', priceDesc: 'Pris: høj til lav', loading: 'Indlæser produkter', closeFilters: 'Luk filtre', clearAll: 'Ryd alle', viewResults: 'Se {count} resultater', noRecent: 'Ingen seneste søgninger', resultOne: 'resultat', resultOther: 'resultater', forQuery: 'for', correctedFrom: 'Rettet fra „{query}“', unavailable: 'Søgning er midlertidigt utilgængelig. Prøv igen.', noProducts: 'Ingen produkter fundet for „{query}“.', viewMore: 'Vis mere', filtersUnavailable: 'Filtrene er midlertidigt utilgængelige.', removeFilter: 'Fjern filteret {label}', availableColours: 'Tilgængelige farver', viewColour: 'Vis {colour}', inColour: 'i', newIn: 'Nyheder', tailoring: 'Skræddersyet', suedeJackets: 'Ruskindsjakker', coOrds: 'Matchende sæt', womensNewIn: 'Nyheder til kvinder', mensNewIn: 'Nyheder til mænd', bestSellers: 'Bestsellere', unisex: 'Unisex', addWishlist: 'Føj til ønskeliste', loadMore: 'Indlæs flere', of: 'af', filtersSelected: '{count} filtre valgt', noFilters: 'Ingen filtre valgt', clearFilters: 'Ryd filtre', viewItems: 'Se {count} varer'
    },
    es: {
      search: 'Buscar', searchResults: 'Resultados de búsqueda', closeSearch: 'Cerrar búsqueda', recent: 'Búsquedas recientes', clear: 'Borrar', trending: 'Búsquedas populares', popular: 'Colecciones populares', suggestions: 'Sugerencias de búsqueda', collections: 'Colecciones', filters: 'Filtros', sort: 'Ordenar por', featured: 'Destacados', priceAsc: 'Precio: de menor a mayor', priceDesc: 'Precio: de mayor a menor', loading: 'Cargando productos', closeFilters: 'Cerrar filtros', clearAll: 'Borrar todo', viewResults: 'Ver {count} resultados', noRecent: 'No hay búsquedas recientes', resultOne: 'resultado', resultOther: 'resultados', forQuery: 'para', correctedFrom: 'Corregido desde «{query}»', unavailable: 'La búsqueda no está disponible temporalmente. Inténtalo de nuevo.', noProducts: 'No se han encontrado productos para «{query}».', viewMore: 'Ver más', filtersUnavailable: 'Los filtros no están disponibles temporalmente.', removeFilter: 'Quitar filtro {label}', availableColours: 'Colores disponibles', viewColour: 'Ver {colour}', inColour: 'en', newIn: 'Novedades', tailoring: 'Sastrería', suedeJackets: 'Chaquetas de ante', coOrds: 'Conjuntos', womensNewIn: 'Novedades mujer', mensNewIn: 'Novedades hombre', bestSellers: 'Más vendidos', unisex: 'Unisex', addWishlist: 'Añadir a favoritos', loadMore: 'Cargar más', of: 'de', filtersSelected: '{count} filtros seleccionados', noFilters: 'Ningún filtro seleccionado', clearFilters: 'Borrar filtros', viewItems: 'Ver {count} artículos'
    },
    fi: {
      search: 'Hae', searchResults: 'Hakutulokset', closeSearch: 'Sulje haku', recent: 'Viimeisimmät haut', clear: 'Tyhjennä', trending: 'Suositut haut', popular: 'Suositut mallistot', suggestions: 'Hakuehdotukset', collections: 'Mallistot', filters: 'Suodattimet', sort: 'Järjestä', featured: 'Suositellut', priceAsc: 'Hinta: halvin ensin', priceDesc: 'Hinta: kallein ensin', loading: 'Ladataan tuotteita', closeFilters: 'Sulje suodattimet', clearAll: 'Tyhjennä kaikki', viewResults: 'Näytä {count} tulosta', noRecent: 'Ei viimeisimpiä hakuja', resultOne: 'tulos', resultOther: 'tulosta', forQuery: 'haulle', correctedFrom: 'Korjattu muodosta ”{query}”', unavailable: 'Haku ei ole tilapäisesti käytettävissä. Yritä uudelleen.', noProducts: 'Haulla ”{query}” ei löytynyt tuotteita.', viewMore: 'Näytä lisää', filtersUnavailable: 'Suodattimet eivät ole tilapäisesti käytettävissä.', removeFilter: 'Poista suodatin {label}', availableColours: 'Saatavilla olevat värit', viewColour: 'Näytä {colour}', inColour: 'värissä', newIn: 'Uutuudet', tailoring: 'Räätälöinti', suedeJackets: 'Mokkajakit', coOrds: 'Yhteensopivat setit', womensNewIn: 'Naisten uutuudet', mensNewIn: 'Miesten uutuudet', bestSellers: 'Myydyimmät', unisex: 'Unisex', addWishlist: 'Lisää toivelistalle', loadMore: 'Lataa lisää', of: '/', filtersSelected: '{count} suodatinta valittu', noFilters: 'Ei suodattimia valittu', clearFilters: 'Tyhjennä suodattimet', viewItems: 'Näytä {count} tuotetta'
    },
    el: {
      search: 'Αναζήτηση', searchResults: 'Αποτελέσματα αναζήτησης', closeSearch: 'Κλείσιμο αναζήτησης', recent: 'Πρόσφατες αναζητήσεις', clear: 'Εκκαθάριση', trending: 'Δημοφιλείς αναζητήσεις', popular: 'Δημοφιλείς συλλογές', suggestions: 'Προτάσεις αναζήτησης', collections: 'Συλλογές', filters: 'Φίλτρα', sort: 'Ταξινόμηση κατά', featured: 'Προτεινόμενα', priceAsc: 'Τιμή: χαμηλή προς υψηλή', priceDesc: 'Τιμή: υψηλή προς χαμηλή', loading: 'Φόρτωση προϊόντων', closeFilters: 'Κλείσιμο φίλτρων', clearAll: 'Εκκαθάριση όλων', viewResults: 'Προβολή {count} αποτελεσμάτων', noRecent: 'Δεν υπάρχουν πρόσφατες αναζητήσεις', resultOne: 'αποτέλεσμα', resultOther: 'αποτελέσματα', forQuery: 'για', correctedFrom: 'Διορθώθηκε από «{query}»', unavailable: 'Η αναζήτηση δεν είναι προσωρινά διαθέσιμη. Δοκιμάστε ξανά.', noProducts: 'Δεν βρέθηκαν προϊόντα για «{query}».', viewMore: 'Προβολή περισσότερων', filtersUnavailable: 'Τα φίλτρα δεν είναι προσωρινά διαθέσιμα.', removeFilter: 'Κατάργηση φίλτρου {label}', availableColours: 'Διαθέσιμα χρώματα', viewColour: 'Προβολή {colour}', inColour: 'σε', newIn: 'Νέες αφίξεις', tailoring: 'Ραπτική', suedeJackets: 'Σουέτ μπουφάν', coOrds: 'Σετ', womensNewIn: 'Νέες αφίξεις γυναικών', mensNewIn: 'Νέες αφίξεις ανδρών', bestSellers: 'Δημοφιλή', unisex: 'Unisex', addWishlist: 'Προσθήκη στη λίστα επιθυμιών', loadMore: 'Φόρτωση περισσότερων', of: 'από', filtersSelected: 'Επιλέχθηκαν {count} φίλτρα', noFilters: 'Δεν επιλέχθηκαν φίλτρα', clearFilters: 'Εκκαθάριση φίλτρων', viewItems: 'Προβολή {count} προϊόντων'
    },
    no: {
      search: 'Søk', searchResults: 'Søkeresultater', closeSearch: 'Lukk søk', recent: 'Nylige søk', clear: 'Tøm', trending: 'Populære søk', popular: 'Populære kolleksjoner', suggestions: 'Søkeforslag', collections: 'Kolleksjoner', filters: 'Filtre', sort: 'Sorter etter', featured: 'Utvalgte', priceAsc: 'Pris: lav til høy', priceDesc: 'Pris: høy til lav', loading: 'Laster produkter', closeFilters: 'Lukk filtre', clearAll: 'Tøm alle', viewResults: 'Vis {count} resultater', noRecent: 'Ingen nylige søk', resultOne: 'resultat', resultOther: 'resultater', forQuery: 'for', correctedFrom: 'Rettet fra «{query}»', unavailable: 'Søket er midlertidig utilgjengelig. Prøv igjen.', noProducts: 'Fant ingen produkter for «{query}».', viewMore: 'Vis mer', filtersUnavailable: 'Filtrene er midlertidig utilgjengelige.', removeFilter: 'Fjern filteret {label}', availableColours: 'Tilgjengelige farger', viewColour: 'Vis {colour}', inColour: 'i', newIn: 'Nyheter', tailoring: 'Skreddersøm', suedeJackets: 'Semskede jakker', coOrds: 'Matchende sett', womensNewIn: 'Nyheter til dame', mensNewIn: 'Nyheter til herre', bestSellers: 'Bestselgere', unisex: 'Unisex', addWishlist: 'Legg til i ønskelisten', loadMore: 'Last inn flere', of: 'av', filtersSelected: '{count} filtre valgt', noFilters: 'Ingen filtre valgt', clearFilters: 'Tøm filtre', viewItems: 'Vis {count} varer'
    },
    pl: {
      search: 'Szukaj', searchResults: 'Wyniki wyszukiwania', closeSearch: 'Zamknij wyszukiwanie', recent: 'Ostatnie wyszukiwania', clear: 'Wyczyść', trending: 'Popularne wyszukiwania', popular: 'Popularne kolekcje', suggestions: 'Sugestie wyszukiwania', collections: 'Kolekcje', filters: 'Filtry', sort: 'Sortuj według', featured: 'Polecane', priceAsc: 'Cena: od najniższej', priceDesc: 'Cena: od najwyższej', loading: 'Ładowanie produktów', closeFilters: 'Zamknij filtry', clearAll: 'Wyczyść wszystko', viewResults: 'Zobacz {count} wyników', noRecent: 'Brak ostatnich wyszukiwań', resultOne: 'wynik', resultOther: 'wyniki', forQuery: 'dla', correctedFrom: 'Poprawiono z „{query}”', unavailable: 'Wyszukiwanie jest tymczasowo niedostępne. Spróbuj ponownie.', noProducts: 'Nie znaleziono produktów dla „{query}”.', viewMore: 'Zobacz więcej', filtersUnavailable: 'Filtry są tymczasowo niedostępne.', removeFilter: 'Usuń filtr {label}', availableColours: 'Dostępne kolory', viewColour: 'Zobacz {colour}', inColour: 'w kolorze', newIn: 'Nowości', tailoring: 'Krawiectwo', suedeJackets: 'Kurtki z zamszu', coOrds: 'Zestawy', womensNewIn: 'Nowości damskie', mensNewIn: 'Nowości męskie', bestSellers: 'Bestsellery', unisex: 'Unisex', addWishlist: 'Dodaj do listy życzeń', loadMore: 'Załaduj więcej', of: 'z', filtersSelected: 'Wybrano {count} filtrów', noFilters: 'Nie wybrano filtrów', clearFilters: 'Wyczyść filtry', viewItems: 'Zobacz {count} produktów'
    },
    pt: {
      search: 'Pesquisar', searchResults: 'Resultados da pesquisa', closeSearch: 'Fechar pesquisa', recent: 'Pesquisas recentes', clear: 'Limpar', trending: 'Pesquisas populares', popular: 'Coleções populares', suggestions: 'Sugestões de pesquisa', collections: 'Coleções', filters: 'Filtros', sort: 'Ordenar por', featured: 'Destaques', priceAsc: 'Preço: mais baixo primeiro', priceDesc: 'Preço: mais alto primeiro', loading: 'A carregar produtos', closeFilters: 'Fechar filtros', clearAll: 'Limpar tudo', viewResults: 'Ver {count} resultados', noRecent: 'Sem pesquisas recentes', resultOne: 'resultado', resultOther: 'resultados', forQuery: 'para', correctedFrom: 'Corrigido de «{query}»', unavailable: 'A pesquisa está temporariamente indisponível. Tente novamente.', noProducts: 'Não foram encontrados produtos para «{query}».', viewMore: 'Ver mais', filtersUnavailable: 'Os filtros estão temporariamente indisponíveis.', removeFilter: 'Remover filtro {label}', availableColours: 'Cores disponíveis', viewColour: 'Ver {colour}', inColour: 'em', newIn: 'Novidades', tailoring: 'Alfaiataria', suedeJackets: 'Casacos de camurça', coOrds: 'Conjuntos', womensNewIn: 'Novidades mulher', mensNewIn: 'Novidades homem', bestSellers: 'Mais vendidos', unisex: 'Unissexo', addWishlist: 'Adicionar à lista de desejos', loadMore: 'Carregar mais', of: 'de', filtersSelected: '{count} filtros selecionados', noFilters: 'Nenhum filtro selecionado', clearFilters: 'Limpar filtros', viewItems: 'Ver {count} artigos'
    },
    ro: {
      search: 'Caută', searchResults: 'Rezultatele căutării', closeSearch: 'Închide căutarea', recent: 'Căutări recente', clear: 'Șterge', trending: 'Căutări populare', popular: 'Colecții populare', suggestions: 'Sugestii de căutare', collections: 'Colecții', filters: 'Filtre', sort: 'Sortează după', featured: 'Recomandate', priceAsc: 'Preț: crescător', priceDesc: 'Preț: descrescător', loading: 'Se încarcă produsele', closeFilters: 'Închide filtrele', clearAll: 'Șterge tot', viewResults: 'Vezi {count} rezultate', noRecent: 'Nicio căutare recentă', resultOne: 'rezultat', resultOther: 'rezultate', forQuery: 'pentru', correctedFrom: 'Corectat din „{query}”', unavailable: 'Căutarea este temporar indisponibilă. Încearcă din nou.', noProducts: 'Nu s-au găsit produse pentru „{query}”.', viewMore: 'Vezi mai multe', filtersUnavailable: 'Filtrele sunt temporar indisponibile.', removeFilter: 'Elimină filtrul {label}', availableColours: 'Culori disponibile', viewColour: 'Vezi {colour}', inColour: 'în', newIn: 'Noutăți', tailoring: 'Croitorie', suedeJackets: 'Jachete din piele întoarsă', coOrds: 'Seturi', womensNewIn: 'Noutăți femei', mensNewIn: 'Noutăți bărbați', bestSellers: 'Cele mai vândute', unisex: 'Unisex', addWishlist: 'Adaugă la lista de dorințe', loadMore: 'Încarcă mai multe', of: 'din', filtersSelected: '{count} filtre selectate', noFilters: 'Niciun filtru selectat', clearFilters: 'Șterge filtrele', viewItems: 'Vezi {count} articole'
    },
    sv: {
      search: 'Sök', searchResults: 'Sökresultat', closeSearch: 'Stäng sökning', recent: 'Senaste sökningarna', clear: 'Rensa', trending: 'Populära sökningar', popular: 'Populära kollektioner', suggestions: 'Sökförslag', collections: 'Kollektioner', filters: 'Filter', sort: 'Sortera efter', featured: 'Utvalda', priceAsc: 'Pris: lågt till högt', priceDesc: 'Pris: högt till lågt', loading: 'Laddar produkter', closeFilters: 'Stäng filter', clearAll: 'Rensa alla', viewResults: 'Visa {count} resultat', noRecent: 'Inga senaste sökningar', resultOne: 'resultat', resultOther: 'resultat', forQuery: 'för', correctedFrom: 'Korrigerat från ”{query}”', unavailable: 'Sökningen är tillfälligt otillgänglig. Försök igen.', noProducts: 'Inga produkter hittades för ”{query}”.', viewMore: 'Visa mer', filtersUnavailable: 'Filtren är tillfälligt otillgängliga.', removeFilter: 'Ta bort filtret {label}', availableColours: 'Tillgängliga färger', viewColour: 'Visa {colour}', inColour: 'i', newIn: 'Nyheter', tailoring: 'Skrädderi', suedeJackets: 'Mockajackor', coOrds: 'Matchande set', womensNewIn: 'Nyheter för dam', mensNewIn: 'Nyheter för herr', bestSellers: 'Bästsäljare', unisex: 'Unisex', addWishlist: 'Lägg till i önskelistan', loadMore: 'Ladda fler', of: 'av', filtersSelected: '{count} filter valda', noFilters: 'Inga filter valda', clearFilters: 'Rensa filter', viewItems: 'Visa {count} produkter'
    }
  };

  var RETRY_SEARCH_COPY = Object.freeze({
    en: 'Retry search',
    fr: 'Réessayer',
    de: 'Erneut versuchen',
    nl: 'Opnieuw proberen',
    it: 'Riprova',
    ar: 'إعادة المحاولة',
    da: 'Prøv igen',
    es: 'Reintentar',
    fi: 'Yritä uudelleen',
    el: 'Δοκιμάστε ξανά',
    no: 'Prøv igjen',
    pl: 'Spróbuj ponownie',
    pt: 'Tentar novamente',
    ro: 'Încearcă din nou',
    sv: 'Försök igen',
  });

  // Search cards had no sold-out indication at all -- more consequential now
  // that the Worker indexes genuinely out-of-stock products instead of
  // hiding them. Locale keys MUST match RETRY_SEARCH_COPY exactly (see the
  // comment above TOP_MATCHES_COPY -- a missing key renders `undefined`).
  var SOLD_OUT_COPY = Object.freeze({
    en: 'Sold Out',
    fr: 'Épuisé',
    de: 'Ausverkauft',
    nl: 'Uitverkocht',
    it: 'Esaurito',
    ar: 'نفدت الكمية',
    da: 'Udsolgt',
    es: 'Agotado',
    fi: 'Loppuunmyyty',
    el: 'Εξαντλήθηκε',
    no: 'Utsolgt',
    pl: 'Wyprzedane',
    pt: 'Esgotado',
    ro: 'Stoc epuizat',
    sv: 'Slutsåld',
  });

  // Non-numeric header/count copy for native-fallback mode. In that mode the
  // response `total` is `/search/suggest.json`'s capped `products.length`, not a
  // proven full-catalogue count, so the header must not assert "N results".
  // Locale keys MUST match RETRY_SEARCH_COPY exactly (a missing key renders
  // `undefined` in that locale); per-locale quotation marks follow `noProducts`.
  var TOP_MATCHES_COPY = Object.freeze({
    en: 'Showing top matches for “{query}”',
    fr: 'Meilleurs résultats pour « {query} »',
    de: 'Top-Treffer für „{query}“',
    nl: 'Beste resultaten voor “{query}”',
    it: 'Migliori risultati per “{query}”',
    ar: 'أفضل النتائج لـ ”{query}“',
    da: 'Bedste resultater for „{query}“',
    es: 'Mejores resultados para «{query}»',
    fi: 'Parhaat osumat haulle ”{query}”',
    el: 'Κορυφαία αποτελέσματα για «{query}»',
    no: 'Beste treff for «{query}»',
    pl: 'Najlepsze wyniki dla „{query}”',
    pt: 'Melhores resultados para «{query}»',
    ro: 'Cele mai bune rezultate pentru „{query}”',
    sv: 'Bästa träffar för ”{query}”',
  });

  // Count-free "View results" label for the filter-drawer CTA in native-fallback
  // mode (the numeric `viewResults` copy would otherwise render "View 10 results"
  // / "View 0 results"). Locale keys MUST match RETRY_SEARCH_COPY exactly.
  var VIEW_RESULTS_GENERIC_COPY = Object.freeze({
    en: 'View results',
    fr: 'Voir les résultats',
    de: 'Ergebnisse anzeigen',
    nl: 'Resultaten bekijken',
    it: 'Vedi i risultati',
    ar: 'عرض النتائج',
    da: 'Se resultater',
    es: 'Ver resultados',
    fi: 'Näytä tulokset',
    el: 'Προβολή αποτελεσμάτων',
    no: 'Se resultater',
    pl: 'Zobacz wyniki',
    pt: 'Ver resultados',
    ro: 'Vezi rezultatele',
    sv: 'Visa resultat',
  });

  // Appended (with an em dash) to `topMatches` while the native-fallback grid
  // is showing, so the degraded state reads as an honest, temporary limitation
  // rather than silence. Deliberately generic wording: this same state is
  // reached by a market/price-context mismatch, a request timeout AND a
  // network error, so a cause-specific phrase (e.g. "for your country") would
  // be false on the other two paths. Locale keys MUST match RETRY_SEARCH_COPY
  // exactly.
  var FALLBACK_DEGRADED_COPY = Object.freeze({
    en: 'full search isn’t available right now',
    fr: 'la recherche complète n’est pas disponible pour le moment',
    de: 'die vollständige Suche ist momentan nicht verfügbar',
    nl: 'volledig zoeken is op dit moment niet beschikbaar',
    it: 'la ricerca completa non è disponibile al momento',
    ar: 'البحث الكامل غير متاح حاليًا',
    da: 'fuld søgning er ikke tilgængelig lige nu',
    es: 'la búsqueda completa no está disponible en este momento',
    fi: 'täysi haku ei ole juuri nyt käytettävissä',
    el: 'η πλήρης αναζήτηση δεν είναι διαθέσιμη αυτή τη στιγμή',
    no: 'fullstendig søk er ikke tilgjengelig akkurat nå',
    pl: 'pełne wyszukiwanie jest obecnie niedostępne',
    pt: 'a pesquisa completa não está disponível neste momento',
    ro: 'căutarea completă nu este disponibilă momentan',
    sv: 'fullständig sökning är inte tillgänglig just nu',
  });

  function text(value) { return String(value == null ? '' : value).normalize('NFKC').trim(); }
  function copyFor(locale) {
    var language = text(locale).split('-')[0].toLowerCase();
    return Object.assign({}, UI_COPY[language] || UI_COPY.en, {
      retrySearch: RETRY_SEARCH_COPY[language] || RETRY_SEARCH_COPY.en,
      topMatches: TOP_MATCHES_COPY[language] || TOP_MATCHES_COPY.en,
      viewResultsGeneric: VIEW_RESULTS_GENERIC_COPY[language] || VIEW_RESULTS_GENERIC_COPY.en,
      soldOut: SOLD_OUT_COPY[language] || SOLD_OUT_COPY.en,
      fallbackDegraded: FALLBACK_DEGRADED_COPY[language] || FALLBACK_DEGRADED_COPY.en,
    });
  }
  function directionForLocale(locale) {
    return text(locale).split('-')[0].toLowerCase() === 'ar' ? 'rtl' : 'ltr';
  }
  function copyText(value, variables) {
    return Object.keys(variables || {}).reduce(function replace(output, key) {
      // A function replacer (not a string) so a $-pattern in the interpolated
      // value (e.g. a customer searching for "$&") is inserted literally --
      // String.prototype.replace treats $&/$$/$`/$' as special only when the
      // replacement argument is a string.
      var replacement = String(variables[key]);
      return output.replace(new RegExp('\\{' + key + '\\}', 'g'), function () { return replacement; });
    }, value || '');
  }
  function fallbackControlsMarkup(copy) {
    return '<div class="mdv-search__fallback-controls" data-native-fallback-notice>'
      + '<p role="status" aria-live="polite">' + esc(copy.filtersUnavailable) + '</p>'
      + '<button type="button" data-retry-search>' + esc(copy.retrySearch) + '</button></div>';
  }
  function suggestionLimitForRuntime(windowLike) {
    try {
      if (windowLike && typeof windowLike.matchMedia === 'function') {
        return windowLike.matchMedia('(max-width: 767px)').matches ? 2 : 4;
      }
    } catch (_) { /* fall through to viewport width */ }
    var width = Number(windowLike && windowLike.innerWidth);
    return Number.isFinite(width) && width <= 767 ? 2 : 4;
  }
  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }
  function amount(money) {
    var value = Number(money && money.amount);
    return Number.isFinite(value) ? value : null;
  }
  var CODE_SUFFIX_CURRENCIES = { CAD: true, AED: true, SAR: true, QAR: true };
  var SYMBOL_CODE_CURRENCIES = { AUD: '$' };
  function formatMoney(money, locale) {
    var value = amount(money);
    var currency = text(money && money.currencyCode).toUpperCase();
    if (value == null) return '';
    if (!currency) return String(value);
    try {
      if (SYMBOL_CODE_CURRENCIES[currency]) {
        return SYMBOL_CODE_CURRENCIES[currency] + new Intl.NumberFormat(locale, {
          minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
          maximumFractionDigits: 2,
        }).format(value) + ' ' + currency;
      }
      if (CODE_SUFFIX_CURRENCIES[currency]) {
        return new Intl.NumberFormat(locale, {
          minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
          maximumFractionDigits: 2,
        }).format(value) + ' ' + currency;
      }
      return new Intl.NumberFormat(locale, {
        style: 'currency', currency: currency,
        minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
        maximumFractionDigits: 2,
      }).format(value);
    } catch (_) { return currency + ' ' + value; }
  }
  function numericId(gid) {
    var match = String(gid || '').match(/(\d+)$/);
    return match ? match[1] : '';
  }
  function absoluteStoreUrl(value) {
    var raw = text(value);
    if (!raw) return '#';
    try {
      var parsed = new URL(raw, root.location && root.location.origin ? root.location.origin : 'https://invalid.local');
      if (root.location && parsed.origin !== root.location.origin) return '#';
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (_) { return '#'; }
  }
  function imageUrl(value, width) {
    var raw = text(value && (value.url || value.src || value));
    if (!raw) return '';
    try {
      var parsed = new URL(raw, root.location && root.location.origin ? root.location.origin : undefined);
      parsed.searchParams.set('width', String(width));
      return parsed.toString();
    } catch (_) { return raw; }
  }
  function collectionHandle(value) {
    var direct = text(value && value.handle).toLowerCase();
    if (direct) return direct;
    var match = text(value && value.url).match(/\/collections\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  }
  function canonicalPopularCollections(copy, collections) {
    var candidates = Array.isArray(collections) ? collections : [];
    return POPULAR_COLLECTION_SLOTS.map(function canonicalSlot(slot) {
      var match = candidates.find(function matchingCollection(candidate) {
        return slot.aliases.indexOf(collectionHandle(candidate)) !== -1;
      });
      return {
        id: text(match && match.id) || slot.handle,
        handle: slot.handle,
        title: copy[slot.titleKey],
        url: slot.url,
        image: match && match.image ? match.image : null,
      };
    });
  }
  function configuredPopularImage(element, index, fallback) {
    var configured = element && typeof element.getAttribute === 'function'
      ? text(element.getAttribute('data-popular-image-' + (index + 1)))
      : '';
    return configured || fallback || '';
  }
  function popularImageLoading(context, activated) {
    return context === 'page' || activated === true ? 'eager' : 'lazy';
  }
  function productHref(card, swatch) {
    var href = absoluteStoreUrl((swatch && swatch.url) || card.url || (card.handle ? '/products/' + encodeURIComponent(card.handle) : ''));
    var variant = numericId(card.leadVariant && card.leadVariant.id);
    if (!variant || swatch) return href;
    var separator = href.indexOf('?') === -1 ? '?' : '&';
    return href + separator + 'variant=' + encodeURIComponent(variant);
  }
  function cardTitle(card, locale) {
    if (card.descriptor && card.colour) return card.descriptor + ' ' + copyFor(locale).inColour + ' ' + (card.colour.label || card.colour);
    return card.descriptor || card.title || '';
  }
  function salePriceMarkup(variant, locale) {
    var price = variant && variant.price;
    var compareAt = variant && variant.compareAtPrice;
    if (amount(price) == null || !text(price && price.currencyCode)) return '';
    var onSale = amount(compareAt) != null && amount(price) != null && amount(compareAt) > amount(price);
    var priceClass = onSale ? ' mdv-search-card__current--sale' : '';
    return '<p class="mdv-search-card__price"><span class="mdv-search-card__current' + priceClass + '">' + esc(formatMoney(price, locale)) + '</span>'
      + (onSale ? '<span class="mdv-search-card__compare">' + esc(formatMoney(compareAt, locale)) + '</span>' : '') + '</p>';
  }
  function containedSwatchCount(rectangles, bounds) {
    var left = Number(bounds && bounds.left);
    var right = Number(bounds && bounds.right);
    if (!Number.isFinite(left) || !Number.isFinite(right) || right <= left) return 0;
    var count = 0;
    for (var index = 0; index < (rectangles || []).length; index += 1) {
      var rectangle = rectangles[index] || {};
      var itemLeft = Number(rectangle.left);
      var itemRight = Number(rectangle.right);
      if (!Number.isFinite(itemLeft) || !Number.isFinite(itemRight) || itemLeft < left - 0.5 || itemRight > right + 0.5) break;
      count += 1;
    }
    return count;
  }
  // Unisex products are shot twice and merchandised women's-first: image slot 1
  // is the womenswear shot, slot 2 the menswear one (the same convention New In
  // relies on). Indexed variants carry no image of their own, so without this a
  // man browsing unisex always gets the women's shot.
  function unisexCardImage(card, gender) {
    var images = card.images || [];
    if (gender !== 'man') return card.image || images[0];
    if (!/:unisex$/i.test(String(card.familyId || ''))) return card.image || images[0];
    return images[1] || card.image || images[0];
  }
  function cardMarkup(card, index, locale, gender, context) {
    var copy = copyFor(locale);
    var href = productHref(card);
    var image = imageUrl(unisexCardImage(card, gender), 720);
    var alt = text((card.image && card.image.altText) || card.title);
    var available = card.available !== false;
    var swatchContext = text(context || 'results').toLowerCase().replace(/[^a-z0-9]+/g, '-');
    var swatchOverflowId = 'mdv-search-' + swatchContext + '-swatch-overflow-' + index;
    var swatches = (card.swatches || []).map(function swatchMarkup(swatch) {
      var colour = text(swatch.colour && (swatch.colour.label || swatch.colour));
      // The class token must come from the stable ASCII colour id, not the
      // localized label: an Arabic label sanitizes to an empty token, so every
      // swatch collapsed onto `swatch-element color ` and rendered one uniform
      // colour. Falls back to the label, then the plain value, so a feed without
      // ids behaves exactly as before.
      var colourToken = text(swatch.colour && (swatch.colour.id || swatch.colour.label || swatch.colour));
      // Locale-independent colour, straight from the feed. Fully anchored so
      // only a bare hex literal can ever reach the style attribute.
      var swatchHex = text(swatch.colour && swatch.colour.swatch);
      var swatchStyle = /^#[0-9a-fA-F]{3,8}$/.test(swatchHex) ? ' style="background-color:' + esc(swatchHex) + '"' : '';
      return '<a class="mdv-search-card__swatch" href="' + esc(productHref(card, swatch)) + '" aria-label="' + esc(copyText(copy.viewColour, { colour: colour || '' })) + '" title="' + esc(colour) + '">'
        + '<span class="swatch-element color ' + esc(colourToken.toLowerCase().replace(/[^a-z0-9]+/g, '-')) + '"' + swatchStyle + '></span></a>';
    }).join('');
    return '<article class="mdv-search-card main-product-item' + (available ? '' : ' mdv-search-card--unavailable') + '" data-product-family="' + esc(card.familyId || card.id) + '">'
      + '<a class="mdv-search-card__image-link" href="' + esc(href) + '" data-mdv-result-link data-result-id="' + esc(card.id) + '">'
      + (image ? '<img src="' + esc(image) + '" alt="' + esc(alt) + '" loading="' + (index < 6 ? 'eager' : 'lazy') + '">' : '')
      + (available ? '' : '<span class="mdv-search-card__sold-out" role="status">' + esc(copy.soldOut) + '</span>') + '</a>'
      + '<div class="mdv-search-card__content"><div class="mdv-search-card__meta">'
      + (card.creative ? '<span class="mdv-search-card__creative">' + esc(card.creative) + '</span>' : '')
      + (swatches ? '<div class="mdv-search-card__swatches" role="group" aria-label="' + esc(copy.availableColours) + '" data-swatch-overflow-group>'
        + '<span class="mdv-search-card__swatch-primary" data-swatch-primary>' + swatches + '</span>'
        + '<button class="mdv-search-card__swatch-more" type="button" data-swatch-toggle aria-controls="' + esc(swatchOverflowId) + '" aria-expanded="false" aria-label="' + esc(copy.availableColours) + '" title="' + esc(copy.availableColours) + '" hidden>+</button>'
        + '<span id="' + esc(swatchOverflowId) + '" class="mdv-search-card__swatch-overflow" data-swatch-overflow hidden></span></div>' : '') + '</div>'
      + '<a class="mdv-search-card__title" href="' + esc(href) + '" data-mdv-result-link data-result-id="' + esc(card.id) + '">' + esc(cardTitle(card, locale)) + '</a>'
      + salePriceMarkup(card.leadVariant, locale) + '</div></article>';
  }
  function facetDefinition(definitions, key) {
    if (Array.isArray(definitions)) return definitions.find(function match(value) { return value && (value.id === key || value.key === key); }) || null;
    return definitions && definitions[key] ? definitions[key] : null;
  }
  function canonicalFacetOptions(key, options) {
    var values = Array.isArray(options) ? options : [];
    if (key !== 'gender') return values;
    var byId = new Map();
    values.forEach(function validGender(option) {
      var id = text(option && option.id).toLowerCase();
      if (SEARCH_GENDER_ORDER.indexOf(id) === -1) return;
      var count = Number(option && (option.optionCount != null ? option.optionCount : option.count));
      if (Number.isFinite(count) && count <= 0) return;
      if (!byId.has(id)) byId.set(id, Object.assign({}, option, { id: id }));
    });
    return SEARCH_GENDER_ORDER.map(function genderOrder(id) { return byId.get(id); }).filter(Boolean);
  }
  function facetEntries(facets, includeGender, definitions, pricingMode) {
    return FACET_ORDER.filter(function filterFacet(key) { return includeGender || key !== 'gender'; })
      .filter(function priceEligibleFacet(key) { return pricingMode !== 'price-free' || PRICE_DERIVED_FACETS.indexOf(key) === -1; })
      .map(function mapFacet(key) {
        var definition = facetDefinition(definitions, key);
        return { key: key, label: text(definition && (definition.label || definition.title)) || key, options: canonicalFacetOptions(key, (facets && facets[key]) || []) };
      })
      .filter(function visibleFacet(group) {
        if (!group.options.length) return false;
        if (group.key !== 'availability') return true;
        var available = new Set(group.options.filter(function valid(option) {
          var count = Number(option && (option.optionCount != null ? option.optionCount : option.count));
          return Number.isFinite(count) && count > 0;
        }).map(function id(option) { return text(option.id); }));
        return available.has('in_stock') && available.has('out_of_stock');
      });
  }
  function emptyFilters() {
    return Object.fromEntries(FACET_ORDER.map(function group(key) { return [key, new Set()]; }));
  }
  /** Unions facet groups across catalogue responses, summing option counts. */
  function mergeFacetGroups(payloads) {
    var merged = {};
    (payloads || []).forEach(function addPayload(payload) {
      var facets = (payload && payload.facets) || {};
      Object.keys(facets).forEach(function addGroup(key) {
        var target = merged[key] || (merged[key] = []);
        (facets[key] || []).forEach(function addOption(option) {
          var id = text(option && option.id);
          if (!id) return;
          var count = Number(option.optionCount != null ? option.optionCount : option.count) || 0;
          var existing = target.find(function match(entry) { return entry.id === id; });
          if (existing) {
            var total = (Number(existing.count) || 0) + count;
            existing.count = total;
            existing.optionCount = total;
            if (option.disabled !== true) existing.disabled = false;
            return;
          }
          target.push(Object.assign({}, option, { id: id, count: count, optionCount: count }));
        });
      });
    });
    return merged;
  }
  function canonicalSearchContext(value) {
    var normalized = text(value).toLowerCase();
    return SEARCH_GENDER_ORDER.indexOf(normalized) >= 0 ? normalized : '';
  }
  function searchContextValue(filters) {
    var selected = filters && filters.gender
      ? new Set(Array.from(filters.gender).map(canonicalSearchContext).filter(Boolean))
      : new Set();
    return SEARCH_GENDER_ORDER.find(function firstSupported(id) { return selected.has(id); }) || '';
  }
  function normalizeRecentEntry(item) {
    var value = typeof item === 'string' ? { query: item } : item;
    if (!value || typeof value !== 'object') return null;
    var query = text(value.query || value.term);
    if (query.length < 2) return null;
    return { query: query, gender: canonicalSearchContext(value.gender) };
  }
  function recentEntryForState(query, filters) {
    return { query: text(query), gender: searchContextValue(filters) };
  }
  function withoutUnsupportedControls(state) {
    return {
      query: text(state && state.query),
      sort: 'relevance',
      filters: emptyFilters(),
    };
  }
  function priceSort(value) {
    return value === 'price-asc' || value === 'price-desc';
  }
  function withoutPriceControls(state) {
    var filters = emptyFilters();
    FACET_ORDER.forEach(function preserveFacet(key) {
      if (PRICE_DERIVED_FACETS.indexOf(key) === -1) filters[key] = new Set((state && state.filters && state.filters[key]) || []);
    });
    return {
      query: text(state && state.query),
      sort: priceSort(state && state.sort) ? 'relevance' : text(state && state.sort) || 'relevance',
      filters: filters,
    };
  }
  function hasPriceControls(state) {
    return priceSort(state && state.sort)
      || PRICE_DERIVED_FACETS.some(function selected(key) {
        return Boolean(state && state.filters && state.filters[key] && state.filters[key].size > 0);
      });
  }
  function withoutMoney(card) {
    var output = Object.assign({}, card || {});
    output.leadVariant = Object.assign({}, output.leadVariant || {});
    delete output.leadVariant.price;
    delete output.leadVariant.compareAtPrice;
    output.variantOptions = (output.variantOptions || []).map(function stripVariantMoney(variant) {
      var next = Object.assign({}, variant || {});
      delete next.price;
      delete next.compareAtPrice;
      return next;
    });
    return output;
  }
  function serializableFilters(filters) {
    return Object.fromEntries(FACET_ORDER.map(function group(key) { return [key, Array.from(filters[key] || [])]; }));
  }
  function committedSearchUrl(api, formAction, currentHref, state) {
    var destination = new root.URL(text(formAction) || '/search', currentHref).toString();
    return api.buildSearchStateUrl(destination, {
      query: text(state && state.query),
      sort: text(state && state.sort) || 'relevance',
      filters: serializableFilters((state && state.filters) || emptyFilters()),
    });
  }
  function telemetryConsent() {
    try {
      var privacy = root.Shopify && root.Shopify.customerPrivacy;
      if (privacy && typeof privacy.analyticsProcessingAllowed === 'function') return privacy.analyticsProcessingAllowed() === true;
      var consent = privacy && typeof privacy.currentVisitorConsent === 'function' ? privacy.currentVisitorConsent() : null;
      return Boolean(consent && consent.analytics === 'yes');
    } catch (_) { return false; }
  }

  function shellState(query, searchSessionStarted) {
    var queryLength = text(query).length;
    var typed = queryLength > 0;
    // The first typed character opens Stage 2 and it stays open for the rest
    // of the session, in both directions: under two characters it browses best
    // sellers, at two or more it runs the query. Stage 1 (recent/trending/
    // popular) only returns after a full close. The old one-character
    // predictive panel is retired -- it was the inconsistent middle state.
    var results = typed || searchSessionStarted === true;
    return {
      typed: typed,
      results: results,
      empty: !results,
      queryDiscovery: false,
    };
  }

  function SearchView(element) {
    this.root = element;
    this.context = element.dataset.context || 'page';
    this.locale = element.dataset.mdvSearchLocale;
    this.copy = copyFor(this.locale);
    this.api = null;
    this.history = null;
    this.state = { query: '', sort: 'relevance', filters: emptyFilters() };
    this.results = [];
    this.payload = null;
    this.executedQuery = '';
    this.nextCursor = null;
    this.searchSessionStarted = false;
    this.contextChoice = '';
    this.activeSuggestion = -1;
    this.openGroups = new Set(['gender']);
    this.requestGeneration = 0;
    this.modalOpener = null;
    this.filterOpener = null;
    this.nativeFallback = false;
    this.pricingMode = null;
    this.discoveryImagesActive = this.context === 'page';
    this.swatchLayoutFrame = 0;
    this.swatchLayoutQueuedAgain = false;
    this.swatchGridWidth = -1;
    this.swatchResizeObserver = null;
    this.elements = {
      topbar: element.querySelector('.mdv-search__topbar'), form: element.querySelector('[data-mdv-search-form]'),
      input: element.querySelector('.mdv-search__input'),
      empty: element.querySelector('[data-empty-state]'), queryDiscovery: element.querySelector('[data-query-discovery]'),
      results: element.querySelector('[data-results]'), loading: element.querySelector('[data-search-loading]'),
      grid: element.querySelector('[data-product-grid]'), emptyResults: element.querySelector('[data-empty-results]'),
      loadMore: element.querySelector('[data-load-more]'), resultCount: element.querySelector('[data-result-count]'),
      mobileResultCount: element.querySelector('[data-mobile-result-count]'), status: element.querySelector('[data-search-status]'),
      searchNotice: element.querySelector('[data-search-notice]'),
      suggestionList: element.querySelector('[data-suggestion-list]'), collections: element.querySelector('[data-collection-suggestions]'),
      filterRail: element.querySelector('[data-filter-rail]'), drawer: element.querySelector('[data-filter-drawer]'),
      drawerBody: element.querySelector('[data-filter-drawer-body]'), recent: element.querySelector('[data-recent-searches]'),
      trending: element.querySelector('[data-trending-searches]'), popularLinks: element.querySelector('[data-popular-links]'),
      popularGrid: element.querySelector('[data-popular-grid]'), searchContext: element.querySelector('[data-search-context]'),
      contextOptions: Array.from(element.querySelectorAll('[data-search-context-option]')),
    };
  }

  SearchView.prototype.applyPriceContextState = function applyPriceContextState() {
    var nativeFallback = this.nativeFallback === true;
    var priceFree = !nativeFallback && this.pricingMode === 'price-free';
    this.root.classList.toggle('mdv-search--price-free', priceFree);
    this.root.classList.toggle('mdv-search--native-fallback', nativeFallback);
    // Keep the layout stable during a native fallback. The rail/drawer render
    // a non-actionable recovery notice instead of stale facet controls.
    this.elements.filterRail.hidden = false;
    this.root.querySelectorAll('[data-open-filters]').forEach(function toggleFilter(button) {
      button.hidden = false;
      button.disabled = false;
    });
    this.root.querySelectorAll('[data-sort-select],[data-mobile-sort-select]').forEach(function toggleSort(select) {
      select.disabled = nativeFallback;
      select.setAttribute('aria-disabled', String(nativeFallback));
      var control = select.closest('label');
      if (control) {
        control.hidden = false;
        control.classList.toggle('is-disabled', nativeFallback);
      }
      Array.from(select.options || []).forEach(function togglePriceOption(option) {
        var hide = priceFree && priceSort(option.value);
        option.hidden = hide;
        option.disabled = hide;
      });
    });
  };

  SearchView.prototype.activateNativeFallback = function activateNativeFallback() {
    var ignoredControlsWereActive = this.state.sort !== 'relevance'
      || FACET_ORDER.some(function selected(key) { return this.state.filters[key].size > 0; }, this);
    this.nativeFallback = true;
    this.pricingMode = null;
    this.state = withoutUnsupportedControls(this.state);
    this.contextChoice = '';
    this.syncSearchContextControls();
    if (ignoredControlsWereActive) this.writeHistory(false);
  };

  SearchView.prototype.failClosedUnavailable = function failClosedUnavailable(query) {
    // No result set can be proven for the current query. Clear the previous
    // query's cards and controls before exposing the retry-only recovery UI.
    this.activateNativeFallback();
    this.payload = {
      nativeFallback: true, total: 0, nextCursor: null, facets: {}, suggestions: [],
      query: { entered: query, executed: query, corrected: null, relaxed: false },
    };
    this.executedQuery = query;
    this.results = [];
    this.nextCursor = null;
    this.renderResults();
    this.elements.emptyResults.hidden = false;
    this.elements.emptyResults.textContent = this.copy.unavailable;
    this.elements.status.textContent = this.copy.unavailable;
  };

  SearchView.prototype.activatePriceFreeMode = function activatePriceFreeMode() {
    var priceControlsWereActive = hasPriceControls(this.state);
    this.nativeFallback = false;
    this.pricingMode = 'price-free';
    this.state = withoutPriceControls(this.state);
    if (priceControlsWereActive) this.writeHistory(false);
    this.applyPriceContextState();
    return priceControlsWereActive;
  };

  SearchView.prototype.applyResponsePricingMode = function applyResponsePricingMode(payload, preserveNativeFallback) {
    this.applyRuntimeContext(payload && payload.meta);
    var mode = text(payload && payload.meta && payload.meta.pricingMode).toLowerCase();
    if (preserveNativeFallback && this.nativeFallback) {
      this.pricingMode = mode;
      this.applyPriceContextState();
      return false;
    }
    if (mode === 'price-free') return this.activatePriceFreeMode();
    this.nativeFallback = false;
    this.pricingMode = 'exact';
    this.applyPriceContextState();
    return false;
  };

  SearchView.prototype.invalidatePriceContext = function invalidatePriceContext() {
    this.requestGeneration += 1;
    this.activatePriceFreeMode();
    this.results = this.results.map(withoutMoney);
    if (this.payload) {
      this.payload = Object.assign({}, this.payload, {
        meta: Object.assign({}, this.payload.meta || {}, { pricingMode: 'price-free' }),
        facets: Object.fromEntries(Object.entries(this.payload.facets || {}).filter(function nonPriceFacet(entry) {
          return PRICE_DERIVED_FACETS.indexOf(entry[0]) === -1;
        })),
        results: this.results,
      });
      this.renderResults();
    } else {
      this.applyPriceContextState();
    }
  };

  SearchView.prototype.ensureApi = function ensureApi() {
    if (this.api) return true;
    try {
      this.api = root.MDVSearchApiV2.createClientFromElement(this.root, {
        getTelemetryConsent: telemetryConsent,
      });
      return true;
    } catch (_) {
      // Generic Glopal targets may initialise after this controller. Keep the
      // price-free native path now and retry on the next customer interaction;
      // createClientFromElement still enforces the full country/currency tuple.
      this.api = null;
      return false;
    }
  };

  SearchView.prototype.refreshBuyerContext = function refreshBuyerContext() {
    if (!this.ensureApi() || typeof this.api.refreshContext !== 'function') return;
    var previous = this.api.context || {};
    var next;
    try {
      next = this.api.refreshContext();
      this.applyRuntimeContext(next);
      if (previous.country === next.country && previous.currency === next.currency && previous.locale === next.locale) return;
    } catch (_) {
      this.invalidatePriceContext();
      if (this.state.query.length >= SEARCH_MIN_QUERY) this.runSearch(false);
      return;
    }
    this.invalidatePriceContext();
    if (this.state.query.length >= SEARCH_MIN_QUERY) this.runSearch(false);
    else this.loadDiscovery();
  };

  SearchView.prototype.init = function init() {
    if (!this.elements.input) return;
    this.applyRuntimeLocale(this.locale);
    if (!this.ensureApi()) {
      this.nativeFallback = true;
    } else {
      this.applyRuntimeContext(this.api.context);
    }
    this.applyCopy();
    this.restoreState();
    if (this.nativeFallback) this.activateNativeFallback();
    this.syncSearchContextControls();
    this.searchSessionStarted = this.hasSearchState();
    this.elements.input.value = this.state.query;
    this.bind();
    this.renderShell();
    this.loadDiscovery();
    if (this.state.query.length >= SEARCH_MIN_QUERY) this.runSearch(false);
    else if (this.browsing()) this.runBrowse();
  };

  SearchView.prototype.applyCopy = function applyCopy() {
    var copy = this.copy;
    this.root.querySelectorAll('[data-mdv-copy]').forEach(function localize(node) {
      var value = copy[node.dataset.mdvCopy];
      if (value) node.textContent = value;
    });
    this.root.querySelectorAll('[data-mdv-copy-placeholder]').forEach(function localizePlaceholder(node) {
      var value = copy[node.dataset.mdvCopyPlaceholder];
      if (value) node.setAttribute('placeholder', value);
    });
    this.root.querySelectorAll('[data-mdv-copy-aria]').forEach(function localizeAria(node) {
      var value = copy[node.dataset.mdvCopyAria];
      if (value) node.setAttribute('aria-label', value);
    });
  };

  SearchView.prototype.applyRuntimeLocale = function applyRuntimeLocale(locale) {
    var next = text(locale);
    if (!next) return false;
    var changed = next.toLowerCase() !== text(this.locale).toLowerCase();
    this.locale = next;
    this.copy = copyFor(next);
    this.root.dataset.mdvSearchLocale = next;
    this.root.setAttribute('lang', next);
    this.root.setAttribute('dir', directionForLocale(next));
    this.applyCopy();
    return changed;
  };

  SearchView.prototype.applyRuntimeContext = function applyRuntimeContext(context) {
    var country = text(context && context.country).toUpperCase();
    var currency = text(context && context.currency).toUpperCase();
    if (/^[A-Z]{2}$/.test(country)) this.root.dataset.mdvSearchCountry = country;
    if (/^[A-Z]{3}$/.test(currency)) this.root.dataset.mdvSearchCurrency = currency;
    return this.applyRuntimeLocale(context && context.locale);
  };

  SearchView.prototype.syncApiContext = function syncApiContext() {
    if (this.api && this.api.context) this.applyRuntimeContext(this.api.context);
  };

  SearchView.prototype.syncSearchContextControls = function syncSearchContextControls() {
    var selected = searchContextValue(this.state.filters);
    if (selected) this.contextChoice = selected;
    else if (this.contextChoice !== 'all') this.contextChoice = '';
    this.elements.contextOptions.forEach(function sync(option) {
      option.checked = option.value === this.contextChoice;
    }, this);
    this.root.dataset.mdvSearchContext = this.contextChoice || 'none';
  };

  SearchView.prototype.setSearchContext = function setSearchContext(value, options) {
    options = options || {};
    var requested = text(value).toLowerCase();
    var selected = canonicalSearchContext(requested);
    var nextChoice = requested === 'all' ? 'all' : selected;
    var previous = searchContextValue(this.state.filters);
    var stateChanged = previous !== selected;
    var firstAllClick = requested === 'all' && !stateChanged && !this.searchSessionStarted && options.deferSearch !== true;
    this.contextChoice = nextChoice;
    this.state.filters.gender = new Set(selected ? [selected] : []);
    this.syncSearchContextControls();
    if (!stateChanged && !firstAllClick) return;
    this.requestGeneration += 1;
    if (this.api && typeof this.api.cancelDebounced === 'function') {
      try { this.api.cancelDebounced('search'); } catch (_) { /* the replacement request must still run */ }
    }
    this.writeHistory(false);
    if (this.state.query.length >= SEARCH_MIN_QUERY && options.deferSearch !== true) this.runSearch(false);
    else if (this.browsing() && options.deferSearch !== true) this.runBrowse();
    else if ((selected || firstAllClick) && !this.searchSessionStarted && options.deferSearch !== true) {
      // A gender click -- or the first click on "All" -- from the untouched,
      // empty search modal must behave like the first typed character does:
      // start the session and show a browse immediately (gender-scoped, or
      // the merged best-sellers view for All), rather than silently updating
      // state with no visible change.
      this.searchSessionStarted = true;
      this.renderShell();
      this.enterBrowse();
      if (this.elements.searchContext && this.elements.searchContext.contains(document.activeElement)) {
        this.elements.input.focus({ preventScroll: true });
      }
    } else {
      this.renderFilters(this.payload ? this.payload.facets : {});
      this.renderRibbons();
    }
    if (previous) this.event('filter_remove', { facet: 'gender', value: previous });
    if (selected) this.event('filter_add', { facet: 'gender', value: selected });
  };

  SearchView.prototype.restoreState = function restoreState() {
    if (this.context !== 'page' || !root.MDVSearchApiV2) return;
    var restored = root.MDVSearchApiV2.readSearchState(root.location.href);
    this.state.query = restored.query;
    this.state.sort = SEARCH_SORTS.indexOf(restored.sort) >= 0 ? restored.sort : 'relevance';
    FACET_ORDER.forEach(function setFacet(key) { this.state.filters[key] = new Set(restored.filters[key] || []); }, this);
    this.contextChoice = searchContextValue(this.state.filters);
    this.history = root.MDVSearchApiV2.createHistoryAdapter(root, function onRestore(next) {
      this.state.query = next.query;
      this.state.sort = SEARCH_SORTS.indexOf(next.sort) >= 0 ? next.sort : 'relevance';
      FACET_ORDER.forEach(function setFacet(key) { this.state.filters[key] = new Set(next.filters[key] || []); }, this);
      this.contextChoice = searchContextValue(this.state.filters);
      this.syncSearchContextControls();
      this.elements.input.value = this.state.query;
      this.searchSessionStarted = this.hasSearchState();
      this.renderShell();
      if (this.state.query.length >= SEARCH_MIN_QUERY) this.runSearch(false);
      else if (this.browsing()) this.runBrowse();
    }.bind(this));
    this.history.start();
  };

  SearchView.prototype.hasSearchState = function hasSearchState() {
    return this.state.query.length >= SEARCH_MIN_QUERY || this.state.sort !== 'relevance'
      || FACET_ORDER.some(function selected(key) { return this.state.filters[key].size > 0; }, this);
  };
  SearchView.prototype.writeHistory = function writeHistory(commit) {
    if (!this.history) return;
    var state = { query: this.state.query, sort: this.state.sort, filters: serializableFilters(this.state.filters) };
    if (commit && typeof this.history.commit === 'function') this.history.commit(state);
    else if (commit) this.history.push(state);
    else this.history.replace(state);
  };
  SearchView.prototype.editHistory = function editHistory() {
    if (!this.history) return;
    var state = { query: this.state.query, sort: this.state.sort, filters: serializableFilters(this.state.filters) };
    if (typeof this.history.edit === 'function') this.history.edit(state);
    else this.history.replace(state);
  };
  SearchView.prototype.recentKey = function recentKey() {
    return ['mdv-search-recent-v2', this.root.dataset.mdvSearchStore, this.root.dataset.mdvSearchCountry, this.locale].join(':');
  };
  SearchView.prototype.readRecent = function readRecent() {
    try { return JSON.parse(root.localStorage.getItem(this.recentKey()) || '[]').map(normalizeRecentEntry).filter(Boolean).slice(0, RECENT_LIMIT); }
    catch (_) { return []; }
  };
  SearchView.prototype.saveRecent = function saveRecent(query) {
    var value = text(query);
    if (value.length < 2) return;
    var entry = recentEntryForState(value, this.state.filters);
    var next = [entry].concat(this.readRecent().filter(function different(item) { return item.query.toLocaleLowerCase() !== value.toLocaleLowerCase(); })).slice(0, RECENT_LIMIT);
    try { root.localStorage.setItem(this.recentKey(), JSON.stringify(next)); } catch (_) { /* privacy mode */ }
    this.renderRecent();
  };

  SearchView.prototype.bind = function bind() {
    var self = this;
    if (this.elements.form) {
      this.elements.form.addEventListener('submit', function submit(event) {
        event.preventDefault();
        self.setQuery(self.elements.input.value, true);
      });
    }
    function syncInput() {
      var previousQuery = self.state.query;
      var wasBrowsing = self.searchSessionStarted && previousQuery.length < SEARCH_MIN_QUERY;
      var rawValue = self.elements.input.value;
      self.state.query = rawValue.trim();
      if (!self.state.query && rawValue) self.elements.input.value = '';
      if (self.state.query.length) self.searchSessionStarted = true;
      self.activeSuggestion = -1;
      self.editHistory();
      self.renderShell();
      if (self.state.query.length >= SEARCH_MIN_QUERY) { self.runSearch(false, true); return; }
      // Entering the under-two-characters state hands the grid over to best
      // sellers -- whether that's the session's first keystroke or a query
      // being deleted back down. Re-fetch only on that crossing, so
      // "ja" -> "j" -> "" doesn't refire on every keystroke.
      if (self.searchSessionStarted && !wasBrowsing) self.enterBrowse();
    }
    this.elements.input.addEventListener('input', syncInput);
    // Safari exposes a native clear control for type=search. Some versions
    // dispatch `search` without a reliable `input` event, so both paths use
    // the same state transition and stale-response cancellation.
    this.elements.input.addEventListener('search', syncInput);
    this.elements.input.addEventListener('keydown', function keydown(event) { self.onInputKeydown(event); });
    this.root.addEventListener('click', function click(event) { self.onClick(event); });
    this.root.addEventListener('change', function change(event) { self.onChange(event); });
    this.root.addEventListener('keydown', function keydown(event) { self.onRootKeydown(event); });
    if (this.context === 'modal') {
      document.addEventListener('pointerdown', function rememberOpener(event) {
        var opener = event.target.closest('li.search, .toggol-menu-search');
        if (opener) self.modalOpener = opener.querySelector('a,button,[tabindex]') || opener;
      }, true);
    }
    // AU/ME still expose a legacy in-page currency selector. Re-check in a
    // microtask so its own change handler has first updated the active runtime
    // signal, then remove stale price-derived UI before any new request.
    document.addEventListener('change', function buyerContextChanged(event) {
      if (!event.target.closest('[name="currencies"], [data-mdv-buyer-country]')) return;
      Promise.resolve().then(function validateChangedContext() { self.refreshBuyerContext(); });
    }, true);
    root.addEventListener('pageshow', function restoredPage() { self.refreshBuyerContext(); });
    root.addEventListener('resize', function resized() { self.queueSwatchLayout(); });
    if (typeof root.ResizeObserver === 'function' && this.elements.grid) {
      this.swatchResizeObserver = new root.ResizeObserver(function resizedGrid(entries) {
        var width = Number(entries[0] && entries[0].contentRect && entries[0].contentRect.width);
        if (!Number.isFinite(width) || Math.abs(width - self.swatchGridWidth) < 0.5) return;
        self.swatchGridWidth = width;
        self.queueSwatchLayout();
      });
      this.swatchResizeObserver.observe(this.elements.grid);
    }
  };

  SearchView.prototype.renderShell = function renderShell() {
    var shell = shellState(this.state.query, this.searchSessionStarted);
    this.root.classList.toggle('mdv-search--results-active', shell.results);
    if (this.elements.searchContext) this.elements.searchContext.hidden = shell.results;
    this.elements.empty.hidden = !shell.empty;
    // Predictive suggestions and collection links belong to Stage 1 only.
    // Once the results shell is active, keep the submitted query editable but
    // give the result controls and catalogue the full vertical space.
    this.elements.queryDiscovery.hidden = !shell.queryDiscovery || shell.results;
    this.elements.results.hidden = !shell.results;
    this.elements.input.setAttribute('aria-expanded', String(shell.typed && !shell.results));
    if (shell.empty) this.renderRecent();
  };

  SearchView.prototype.renderRecent = function renderRecent() {
    var recent = this.readRecent();
    var clear = this.root.querySelector('[data-clear-recent]');
    if (clear) clear.hidden = recent.length === 0;
    this.elements.recent.innerHTML = recent.length
      ? recent.map(function item(entry) {
        return '<li><button type="button" data-recent-query="' + esc(entry.query) + '" data-recent-gender="' + esc(entry.gender) + '">' + esc(entry.query) + '</button></li>';
      }).join('')
      : '<li class="mdv-search__empty-note">' + esc(this.copy.noRecent) + '</li>';
  };

  SearchView.prototype.loadDiscovery = async function loadDiscovery() {
    this.renderRecent();
    var fallbackTrending = [this.copy.newIn, this.copy.tailoring, this.copy.suedeJackets, this.copy.coOrds];
    var popular = [];
    if (this.ensureApi()) {
      try {
        var payload = await this.api.discovery();
        this.applyResponsePricingMode(payload, true);
        var apiTrending = (payload.trending || []).map(function label(item) { return text(item.label || item.query || item); }).filter(Boolean);
        fallbackTrending = apiTrending.length ? apiTrending : fallbackTrending;
        popular = payload.popularCollections || [];
      } catch (error) {
        this.syncApiContext();
        if (!root.MDVSearchApiV2.shouldUseNativeFallback(error)) console.warn('[MDV search v2]', error);
      }
    }
    this.elements.trending.innerHTML = fallbackTrending.slice(0, 4).map(function term(value) {
      return '<li><button type="button" data-search-term="' + esc(value) + '">' + esc(value) + '</button></li>';
    }).join('');
    var cards = canonicalPopularCollections(this.copy, popular);
    this.elements.popularLinks.innerHTML = cards.map(function link(item) {
      return '<li><a href="' + esc(absoluteStoreUrl(item.url)) + '">' + esc(item.title || item.label) + '</a></li>';
    }).join('');
    this.elements.popularGrid.innerHTML = cards.map(function card(item, index) {
      var image = imageUrl(configuredPopularImage(this.root, index, item.image), 1000);
      var loading = popularImageLoading(this.context, this.discoveryImagesActive);
      return '<a class="mdv-search__popular-card" href="' + esc(absoluteStoreUrl(item.url)) + '"><span class="mdv-search__popular-image">'
        + (image ? '<img src="' + esc(image) + '" alt="" loading="' + loading + '" decoding="async"' + (loading === 'eager' && index < 2 ? ' fetchpriority="high"' : '') + '>' : '')
        + '</span><span>' + esc(item.title || item.label) + '</span></a>';
    }, this).join('');
  };

  SearchView.prototype.activatePopularImages = function activatePopularImages() {
    this.discoveryImagesActive = true;
    this.elements.popularGrid.querySelectorAll('img').forEach(function activate(image, index) {
      image.loading = 'eager';
      if (index < 2) image.fetchPriority = 'high';
    });
  };

  SearchView.prototype.runSuggest = async function runSuggest() {
    var query = this.state.query;
    if (!query) return;
    try {
      var apiAvailable = this.ensureApi();
      var payload = apiAvailable ? await this.api.debouncedSuggest({ query: query, limit: 4 }) : await this.nativeSuggest(query);
      if (query !== this.state.query) return;
      if (apiAvailable) this.applyResponsePricingMode(payload, true);
      this.renderSuggestions(payload.suggestions || [], payload.collections || []);
    } catch (error) {
      if (error instanceof root.MDVSearchApiV2.SearchApiAbortedError) return;
      this.syncApiContext();
      if (!root.MDVSearchApiV2.shouldUseNativeFallback(error)) { this.renderSuggestions([], []); return; }
      try {
        var fallback = await this.nativeSuggest(query);
        if (query === this.state.query) this.renderSuggestions(fallback.suggestions, fallback.collections);
      } catch (_) { this.renderSuggestions([], []); }
    }
  };
  SearchView.prototype.nativeSuggest = async function nativeSuggest(query) {
    // resources[limit] is shared ACROSS types by default (Shopify splits one
    // pool across query/collection/product), which capped this at 4 queries +
    // 3 collections + 3 products. limit_scope=each applies the 10 cap to each
    // type independently -- verified live to yield 10 products, 10 queries,
    // 7 collections, a strict improvement with no change to the types requested.
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=query,collection,product&resources[limit]=10&resources[limit_scope]=each';
    // Every MDVSearchApiV2 request races against a 6s abort; this raw fetch
    // (used only once the Worker has already signalled fallback) did not --
    // a stalled connection here left the loading spinner spinning forever,
    // since runSearch's finally() never runs while this await is suspended.
    var controller = new AbortController();
    var timeoutId = root.setTimeout(function () { controller.abort(); }, 6000);
    var response;
    try {
      response = await fetch(url, { credentials: 'same-origin', headers: { accept: 'application/json' }, signal: controller.signal });
    } finally {
      root.clearTimeout(timeoutId);
    }
    if (!response.ok) throw new Error('Native search unavailable');
    var payload = await response.json();
    var results = payload.resources && payload.resources.results ? payload.resources.results : {};
    return {
      suggestions: (results.queries || []).map(function queryItem(item) { return item.text || item.styled_text; }).filter(Boolean),
      collections: (results.collections || []).map(function collection(item) { return { title: item.title, url: item.url }; }),
      products: results.products || [],
    };
  };
  SearchView.prototype.renderSuggestions = function renderSuggestions(suggestions, collections) {
    var uid = this.elements.input.id + '-option-';
    var visibleSuggestionLimit = suggestionLimitForRuntime(root);
    this.elements.suggestionList.innerHTML = suggestions.slice(0, visibleSuggestionLimit).map(function item(value, index) {
      var label = text(value.label || value.query || value);
      return '<button id="' + esc(uid + index) + '" class="mdv-search__suggestion" type="button" role="option" aria-selected="false" data-search-term="' + esc(label) + '">' + esc(label) + '</button>';
    }).join('');
    this.elements.collections.innerHTML = collections.slice(0, 4).map(function item(value) {
      return '<a class="mdv-search__collection-suggestion" href="' + esc(absoluteStoreUrl(value.url)) + '">' + esc(value.title || value.label) + '</a>';
    }).join('');
  };

  SearchView.prototype.browsing = function browsing() {
    return this.searchSessionStarted === true && this.state.query.length < SEARCH_MIN_QUERY;
  };
  /** Resets the query-specific surface, keeps the gender, then loads best sellers. */
  SearchView.prototype.enterBrowse = function enterBrowse() {
    this.requestGeneration += 1;
    if (this.api && typeof this.api.cancelAll === 'function') {
      try { this.api.cancelAll(); } catch (_) { /* dropping under two characters must still complete */ }
    }
    this.elements.input.removeAttribute('aria-activedescendant');
    this.elements.input.setAttribute('aria-expanded', 'false');
    this.elements.suggestionList.innerHTML = '';
    this.elements.collections.innerHTML = '';
    // The gender carries over from Stage 1 (or from the query that was just
    // deleted); every other facet and the sort go back to the full catalogue.
    this.state.filters = emptyFilters();
    this.state.sort = 'relevance';
    // 'all' is a Stage 1 shorthand for "no gender preference", not a facet
    // value -- writing it into the filter matches no product and empties the
    // results the moment the query reaches a real search.
    var carriedGender = canonicalSearchContext(this.contextChoice);
    if (carriedGender) this.state.filters.gender = new Set([carriedGender]);
    this.executedQuery = '';
    this.nextCursor = null;
    this.openGroups = new Set(['gender']);
    this.root.querySelectorAll('[data-sort-select],[data-mobile-sort-select]').forEach(function reset(select) { select.value = 'relevance'; });
    this.runBrowse();
  };
  SearchView.prototype.runBrowse = async function runBrowse() {
    var generation = ++this.requestGeneration;
    var source = BROWSE_SOURCES[canonicalSearchContext(this.contextChoice) || 'all'];
    if (!this.ensureApi()) { this.renderBrowse([], null, null, generation, true); return; }
    this.elements.loading.hidden = false;
    var sort = this.state.sort === 'relevance' ? 'featured' : this.state.sort;
    var self = this;
    // Always an empty query: a one-character query would text-score the
    // collection rather than leave it in pure velocity order.
    function fetchCollection(handle, limit) {
      return self.api.searchWithScope({
        query: '', scope: 'collection', collectionHandle: handle,
        sort: sort, limit: limit, includeGender: false,
      }).catch(function unavailable() { return null; });
    }
    try {
      // The grid comes from the best-seller collections (velocity order) while
      // the facets come from the full catalogue, so every filter still lists
      // the whole site's options rather than the browsed sample's.
      var results = await Promise.all([
        Promise.all(source.best.map(function best(handle) { return fetchCollection(handle, BROWSE_LIMIT); })),
        Promise.all(source.catalog.map(function catalog(handle) { return fetchCollection(handle, 1); })),
      ]);
      if (generation !== this.requestGeneration) return;
      var bestPayloads = results[0];
      var catalogPayloads = results[1];
      var seen = new Set();
      var merged = [];
      // Interleave so a merged view alternates women's and men's best sellers
      // instead of showing one collection's full run before the other's.
      for (var slot = 0; slot < BROWSE_LIMIT; slot += 1) {
        bestPayloads.forEach(function pick(payload) {
          var card = payload && payload.results ? payload.results[slot] : null;
          var key = card && card.id;
          if (!card || !key || seen.has(key)) return;
          seen.add(key);
          merged.push(card);
        });
      }
      // Each source list arrives sorted, but interleaving two of them destroys
      // that order, so a price sort has to be re-applied across the merge.
      if (priceSort(this.state.sort) && source.best.length > 1) {
        var descending = this.state.sort === 'price-desc';
        merged.sort(function byPrice(left, right) {
          var leftPrice = amount(left.leadVariant && left.leadVariant.price);
          var rightPrice = amount(right.leadVariant && right.leadVariant.price);
          if (leftPrice == null && rightPrice == null) return 0;
          if (leftPrice == null) return 1;
          if (rightPrice == null) return -1;
          return descending ? rightPrice - leftPrice : leftPrice - rightPrice;
        });
      }
      var definitions = (catalogPayloads.concat(bestPayloads).find(function present(payload) {
        return payload && payload.facetDefinitions;
      }) || {}).facetDefinitions;
      // Every fetchCollection failure is swallowed to null. If ALL of them
      // failed, the empty grid is an outage or an unservable context (e.g. a
      // currency the Worker can't price), not an empty catalogue -- so show the
      // native "unavailable" copy instead of a silent blank panel.
      var browseUnavailable = bestPayloads.every(function failed(payload) { return payload === null; });
      this.renderBrowse(merged.slice(0, BROWSE_LIMIT), mergeFacetGroups(catalogPayloads), definitions, generation, browseUnavailable);
    } catch (_) {
      if (generation !== this.requestGeneration) return;
      this.renderBrowse([], null, null, generation, true);
    } finally { if (generation === this.requestGeneration) this.elements.loading.hidden = true; }
  };
  SearchView.prototype.normalizeGenderLabels = function normalizeGenderLabels(payload) {
    var options = payload && payload.facets && payload.facets.gender;
    if (!Array.isArray(options)) return;
    // GENDER_LABELS is the English house style (singular "Woman"/"Man"), so it
    // must only override English. On every other locale the API's own
    // translated label is correct and overriding it would force English.
    if (!/^en\b/i.test(String(this.locale || 'en'))) return;
    options.forEach(function relabel(option) {
      var id = canonicalSearchContext(option && option.id);
      if (id && GENDER_LABELS[id]) option.label = GENDER_LABELS[id];
    });
  };
  /**
   * The catalogue facets as fetched, with the gender group layered on top --
   * a collection response never carries one, and its counts must describe the
   * whole catalogue rather than the best-seller sample being displayed.
   */
  SearchView.prototype.browseFacets = function browseFacets() {
    var counts = this.browseCounts || {};
    var facets = Object.assign({}, this.browseCatalogueFacets || {});
    facets.gender = SEARCH_GENDER_ORDER.map(function option(id) {
      var count = counts[id];
      return {
        id: id,
        label: GENDER_LABELS[id],
        // A pending count is left undefined so canonicalFacetOptions keeps the
        // option visible; a zero would drop it from the rail entirely.
        count: Number.isFinite(Number(count)) ? Number(count) : undefined,
      };
    }, this);
    return facets;
  };
  /**
   * A collection response omits the gender facet (and its definition) because
   * the client always requests includeGender=false, so the group heading is
   * taken from the theme's own Stage 1 gender-selector label instead of
   * falling back to the raw facet key.
   */
  SearchView.prototype.browseDefinitionSet = function browseDefinitionSet() {
    var definitions = Object.assign({}, this.browseDefinitions || {});
    if (!definitions.gender) {
      var label = text(this.root.querySelector('.mdv-search__context-label') && this.root.querySelector('.mdv-search__context-label').textContent);
      definitions.gender = { id: 'gender', label: label || this.copy.filters };
    }
    return definitions;
  };
  SearchView.prototype.renderBrowse = function renderBrowse(cards, catalogueFacets, definitions, generation, unavailable) {
    if (generation != null && generation !== this.requestGeneration) return;
    this.results = cards || [];
    if (catalogueFacets) this.browseCatalogueFacets = catalogueFacets;
    this.browseDefinitions = definitions || this.browseDefinitions || null;
    this.payload = { total: this.results.length, facets: this.browseFacets(), facetDefinitions: this.browseDefinitionSet(), browse: true };
    this.nextCursor = null;
    var label = this.copy.bestSellers || BROWSE_LABEL;
    this.elements.resultCount.textContent = label;
    this.elements.mobileResultCount.textContent = label;
    // Browsing never carries a correction or a native-fallback degradation --
    // clear any notice left behind by a previous typed search so it can't
    // survive into this render path.
    if (this.elements.searchNotice) this.elements.searchNotice.textContent = '';
    if (this.context === 'page' && root.document) root.document.title = label;
    this.elements.status.textContent = this.results.length ? label + '.' : '';
    this.elements.grid.innerHTML = this.results.map(function card(entry, index) { return cardMarkup(entry, index, this.locale, canonicalSearchContext(this.contextChoice)); }, this).join('');
    // An empty grid caused by every source failing must not read as a blank
    // panel: surface the same "unavailable" copy a failed typed search shows.
    var showUnavailable = unavailable === true && this.results.length === 0;
    this.elements.emptyResults.hidden = !showUnavailable;
    this.elements.emptyResults.textContent = showUnavailable ? this.copy.unavailable : '';
    if (showUnavailable) this.elements.status.textContent = this.copy.unavailable;
    this.elements.loadMore.innerHTML = '';
    this.applyPriceContextState();
    this.renderFilters(this.payload.facets);
    this.renderRibbons();
    this.loadBrowseCounts();
  };
  /** Full-catalogue totals per gender, fetched once and reused all session. */
  SearchView.prototype.loadBrowseCounts = async function loadBrowseCounts() {
    if (this.browseCounts || this.browseCountsPending || !this.ensureApi()) return;
    this.browseCountsPending = true;
    var self = this;
    var totals = {};
    await Promise.all(SEARCH_GENDER_ORDER.map(function count(id) {
      return self.api.searchWithScope({
        query: '', scope: 'collection', collectionHandle: BROWSE_CATALOGUES[id],
        sort: 'featured', limit: 1, includeGender: false,
      }).then(function total(payload) {
        if (payload && Number.isFinite(Number(payload.total))) totals[id] = Number(payload.total);
      }).catch(function unavailable() { /* the option renders without a count */ });
    }));
    this.browseCountsPending = false;
    if (!Object.keys(totals).length) return;
    this.browseCounts = totals;
    if (this.browsing()) {
      this.payload = { total: this.results.length, facets: this.browseFacets(), facetDefinitions: this.browseDefinitionSet(), browse: true };
      this.renderFilters(this.payload.facets);
    }
  };

  SearchView.prototype.runSearch = async function runSearch(append, debounced) {
    var query = this.state.query || this.executedQuery;
    if (query.length < SEARCH_MIN_QUERY) return;
    var generation = ++this.requestGeneration;
    this.elements.loading.hidden = false;
    if (!append) this.elements.emptyResults.hidden = true;
    try {
      var input = {
        query: query, filters: serializableFilters(this.state.filters), sort: this.state.sort,
        limit: 48, cursor: append ? this.nextCursor : null,
      };
      var payload;
      if (this.ensureApi()) payload = debounced ? await this.api.debouncedSearch(input) : await this.api.searchWithScope(input);
      else payload = await this.nativeSearch(query);
      if (generation !== this.requestGeneration) return;
      if (payload.nativeFallback) this.activateNativeFallback();
      else if (this.applyResponsePricingMode(payload)) return await this.runSearch(false, false);
      this.payload = payload;
      this.executedQuery = query;
      this.results = append ? this.results.concat(payload.results || []) : (payload.results || []);
      this.nextCursor = payload.nextCursor || null;
      this.renderResults();
      if (!append && payload.total === 0) this.event('zero_results', { query: query });
      // The visible "Corrected from ..." notice was the only surface where a
      // human would ever see a correction fire -- it is gone from the count
      // line now (see renderResults), so a wrong correction must not also go
      // invisible to the business. Fired once per fresh (non-append) search,
      // mirroring zero_results above, rather than folded into the existing
      // search_submitted event, which already fires synchronously from
      // setQuery()/commitToResultsPage() before this response -- and
      // therefore the correction -- is known.
      // The worker's EVENT_TYPES allowlist must carry 'search_corrected' or this
      // is silently dropped -- see worker/src/analytics.js.
      if (!append && payload.nativeFallback !== true && payload.query && payload.query.corrected) {
        var correctedForEvent = text(payload.query.corrected);
        var enteredForEvent = text(payload.query.entered || query);
        if (correctedForEvent && enteredForEvent && correctedForEvent !== enteredForEvent) {
          this.event('search_corrected', { query: enteredForEvent, originalQuery: enteredForEvent, correctedQuery: correctedForEvent });
        }
      }
    } catch (error) {
      if (this.api && error instanceof root.MDVSearchApiV2.SearchApiAbortedError) return;
      if (generation !== this.requestGeneration) return;
      this.syncApiContext();
      var priceControlConflict = error && (error.code === 'PRICE_FILTER_UNAVAILABLE' || error.code === 'PRICE_SORT_UNAVAILABLE');
      if (priceControlConflict) {
        var cleared = this.activatePriceFreeMode();
        if (cleared) return await this.runSearch(false, false);
      }
      // A "Load more" failure must never wipe the page(s) of results already
      // on screen. failClosedUnavailable() and the fallback-success path
      // below both replace the whole result set, which is correct for an
      // initial search but would otherwise destroy everything the shopper
      // has already scrolled through just because one extra page failed.
      // The native-fallback success path is *also* treated as a failure here
      // when appending: it returns Shopify's capped predictive results, a
      // different (and smaller) set than the exact paginated results already
      // rendered -- silently mixing the two would look like data loss, not
      // a page 2 that merely failed to load.
      if (append) {
        this.elements.loadMore.innerHTML = '<button type="button" data-load-more-button>' + esc(this.copy.unavailable) + '</button>';
        return;
      }
      if (!root.MDVSearchApiV2.shouldUseNativeFallback(error)) {
        this.failClosedUnavailable(query);
        return;
      }
      try {
        var nativePayload = await this.nativeSearch(query);
        if (generation !== this.requestGeneration) return;
        this.activateNativeFallback();
        this.payload = nativePayload;
        this.executedQuery = query;
        this.results = nativePayload.results;
        this.nextCursor = null;
        this.renderResults();
      } catch (_) {
        // Neither V2 nor Shopify native search can prove results for the
        // current query. Fail closed instead of leaving the previous query's
        // products, prices or facets interactive under a new search term.
        this.failClosedUnavailable(query);
      }
    } finally { if (generation === this.requestGeneration) this.elements.loading.hidden = true; }
  };
  SearchView.prototype.nativeSearch = async function nativeSearch(query) {
    var payload = await this.nativeSuggest(query);
    var products = payload.products || [];
    return {
      nativeFallback: true, total: products.length, nextCursor: null, facets: {}, suggestions: payload.suggestions,
      query: { entered: query, executed: query, corrected: null, relaxed: false },
      results: products.map(function product(item) {
        return {
          id: item.id, familyId: item.id, title: item.title, descriptor: item.title, url: item.url,
          image: item.image || item.featured_image,
          // Predictive-search prices are intentionally omitted. When the exact
          // Shopify country/currency context cannot be proven, discovery stays
          // available without fabricated FX, sale messaging or price facets.
          leadVariant: { id: item.variant_id },
          swatches: [],
        };
      }),
    };
  };

  SearchView.prototype.layoutSwatchGroup = function layoutSwatchGroup(group) {
    var primary = group.querySelector('[data-swatch-primary]');
    var overflow = group.querySelector('[data-swatch-overflow]');
    var toggle = group.querySelector('[data-swatch-toggle]');
    if (!primary || !overflow || !toggle) return;

    var wasExpanded = toggle.getAttribute('aria-expanded') === 'true';
    group.classList.remove('is-expanded', 'is-compact');
    overflow.hidden = true;
    Array.from(overflow.children).forEach(function restore(swatch) { primary.appendChild(swatch); });

    var swatches = Array.from(primary.querySelectorAll('.mdv-search-card__swatch'));
    if (!swatches.length) {
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      return;
    }

    toggle.hidden = false;
    var hiddenCount = swatches.length;
    var visibleCount = 0;
    for (var attempt = 0; attempt < 3; attempt += 1) {
      toggle.textContent = '+' + Math.max(1, hiddenCount);
      var bounds = primary.getBoundingClientRect();
      if (bounds.width <= 0) {
        toggle.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        return;
      }
      visibleCount = containedSwatchCount(swatches.map(function rectangle(swatch) { return swatch.getBoundingClientRect(); }), bounds);
      visibleCount = Math.max(1, Math.min(swatches.length, visibleCount));
      var nextHiddenCount = swatches.length - visibleCount;
      if (nextHiddenCount === hiddenCount) break;
      hiddenCount = nextHiddenCount;
    }

    if (hiddenCount <= 0) {
      toggle.hidden = true;
      toggle.removeAttribute('data-swatch-hidden');
      toggle.setAttribute('aria-expanded', 'false');
      return;
    }

    swatches.slice(visibleCount).forEach(function moveToOverflow(swatch) { overflow.appendChild(swatch); });
    // The grid can settle a few pixels narrower after the disclosure text and
    // overflow contents update. Recheck the rendered edge so a final swatch is
    // never partially hidden by the primary row's overflow clipping.
    while (primary.children.length > 1) {
      hiddenCount = overflow.children.length;
      toggle.textContent = '+' + hiddenCount;
      var primaryBounds = primary.getBoundingClientRect();
      var lastSwatch = primary.lastElementChild;
      var lastBounds = lastSwatch && lastSwatch.getBoundingClientRect();
      if (containedSwatchCount(lastBounds ? [lastBounds] : [], primaryBounds) === 1) break;
      overflow.insertBefore(lastSwatch, overflow.firstChild);
    }
    hiddenCount = overflow.children.length;
    toggle.setAttribute('data-swatch-hidden', String(hiddenCount));
    var label = group.getAttribute('aria-label') || '';
    toggle.setAttribute('aria-label', label + ': +' + hiddenCount);
    toggle.setAttribute('title', label + ': +' + hiddenCount);
    toggle.setAttribute('aria-expanded', String(wasExpanded));
    toggle.textContent = wasExpanded ? '−' : '+' + hiddenCount;
    group.classList.add('is-compact');
    group.classList.toggle('is-expanded', wasExpanded);
    overflow.hidden = !wasExpanded;
  };

  SearchView.prototype.layoutSwatches = function layoutSwatches() {
    this.root.classList.add('mdv-search--swatch-overflow-ready');
    this.root.querySelectorAll('[data-swatch-overflow-group]').forEach(function layout(group) {
      this.layoutSwatchGroup(group);
    }, this);
  };

  SearchView.prototype.queueSwatchLayout = function queueSwatchLayout() {
    if (this.swatchLayoutFrame) {
      this.swatchLayoutQueuedAgain = true;
      return;
    }
    var self = this;
    function layout() {
      self.swatchLayoutFrame = 0;
      self.layoutSwatches();
      if (self.swatchLayoutQueuedAgain) {
        self.swatchLayoutQueuedAgain = false;
        self.queueSwatchLayout();
      }
    }
    this.swatchLayoutFrame = typeof root.requestAnimationFrame === 'function'
      ? root.requestAnimationFrame(layout)
      : root.setTimeout(layout, 0);
  };

  SearchView.prototype.renderResults = function renderResults() {
    this.normalizeGenderLabels(this.payload);
    var payload = this.payload || { total: 0, facets: {} };
    var count = Number(payload.total || 0);
    var queryLabel = this.state.query || this.executedQuery;
    // In native-fallback mode `payload.total` is not a proven full-catalogue
    // count: with results it is `/search/suggest.json`'s capped `products.length`
    // (e.g. 10), and with no results it is 0 from a fail-closed recovery.
    // Rendering it as "N results" asserts a count that was never proven, so
    // branch to non-numeric copy (results present) or a blank label
    // (fail-closed — failClosedUnavailable then supplies the recovery copy).
    // The Worker only corrects the shopper's typed term when it scored zero
    // results (see the `if (textQuery && !scored.length)` guard in the
    // Worker's search.js) -- so a corrected response describes results for
    // the corrected term, never the entered one. Swap the label onto the
    // corrected term so it stops asserting a count for a term that had zero,
    // and keep the entered term only as the plain-text suffix below. No link
    // back to the entered term: re-running it is the identical request and
    // deterministically re-corrects to the same result, so there is nothing
    // to "search instead" for.
    var correctedTerm = '';
    var enteredTerm = '';
    if (payload.nativeFallback !== true && payload.query && payload.query.corrected) {
      var candidateCorrected = text(payload.query.corrected);
      var candidateEntered = text(payload.query.entered || queryLabel);
      if (candidateCorrected && candidateEntered && candidateCorrected !== candidateEntered) {
        correctedTerm = candidateCorrected;
        enteredTerm = candidateEntered;
        queryLabel = correctedTerm;
      }
    }
    // The "Corrected from ..." suffix was dropped from the visible count line
    // (2026-07-28): it read as an apology for a bad correction rather than a
    // mitigation, and the real fix is the correction vocabulary itself, which
    // now lands separately. The corrected TERM still labels the count -- see
    // the queryLabel swap above -- only the appended suffix is gone. The
    // aria-live status region alone keeps the full text (below): it is not a
    // visible surface, and screen reader users are over-served rather than
    // under-served by the extra context. The document title deliberately does
    // NOT carry it -- a browser tab IS visible, and the title's stated job is
    // to mirror the visible count line exactly.
    var desktopLabel;
    var mobileLabel;
    var noticeText = '';
    if (payload.nativeFallback === true) {
      // FALLBACK_DEGRADED_COPY is about degraded system state (missing
      // filters, degraded pricing), not a correction, so it survives here.
      // It cannot live in the mobile count cell: that cell is nowrap/ellipsis
      // and capped at 45vw (measured 169px on AU at 375px) -- deliberately
      // tuned in an earlier fix to stop long queries pushing the mobile
      // Filters/Sort actions column off-screen -- while the fallback copy
      // needs ~390px to render on one line. So mobile shortens to the bare
      // "Top matches" label and the explanatory clause moves to the
      // full-width, wrap-permitted [data-search-notice] element below
      // .mdv-search__mobile-summary. Desktop is unaffected: its toolbar cell
      // has room, so it keeps the single verified inline string.
      var hasFallbackResults = this.results.length > 0;
      var topMatchesLabel = hasFallbackResults ? copyText(this.copy.topMatches, { query: queryLabel }) : '';
      desktopLabel = hasFallbackResults ? topMatchesLabel + ' — ' + this.copy.fallbackDegraded : '';
      mobileLabel = topMatchesLabel;
      noticeText = hasFallbackResults ? this.copy.fallbackDegraded : '';
    } else {
      desktopLabel = count.toLocaleString(this.locale) + ' ' + (count === 1 ? this.copy.resultOne : this.copy.resultOther) + ' ' + this.copy.forQuery + ' “' + queryLabel + '”';
      mobileLabel = desktopLabel;
    }
    // correctedFrom already carries its own locale-correct quotation marks
    // around {query} (matching noProducts's per-locale convention), so no
    // quoting is added here. Used only for the aria-live status now -- see
    // the comment above.
    var correctedSuffix = correctedTerm ? copyText(this.copy.correctedFrom, { query: enteredTerm }) : '';
    var ariaLabel = correctedSuffix ? desktopLabel + '. ' + correctedSuffix : desktopLabel;
    this.elements.resultCount.textContent = desktopLabel;
    this.elements.mobileResultCount.textContent = mobileLabel;
    if (this.elements.searchNotice) this.elements.searchNotice.textContent = noticeText;
    // Keep the document title honest: mirror the body count label so the tab
    // never asserts a different (native SSR) count than the rendered results,
    // and never asserts a fake count in fallback mode.
    if (this.context === 'page' && root.document) root.document.title = desktopLabel || this.copy.unavailable;
    this.elements.status.textContent = ariaLabel ? ariaLabel + '.' : '';
    this.elements.grid.innerHTML = this.results.map(function card(card, index) { return cardMarkup(card, index, this.locale, canonicalSearchContext(this.contextChoice), this.context); }, this).join('');
    this.queueSwatchLayout();
    this.elements.emptyResults.hidden = this.results.length > 0;
    if (!this.results.length) {
      var recovery = payload.recovery || {};
      var recoveryActions = [];
      if ((recovery.clearFilters || []).length) {
        recoveryActions.push('<button type="button" data-clear-filters>' + esc(this.copy.clearFilters) + '</button>');
      }
      (recovery.queries || []).forEach(function suggestion(value) {
        recoveryActions.push('<button type="button" data-search-term="' + esc(value) + '">' + esc(value) + '</button>');
      });
      this.elements.emptyResults.innerHTML = '<p>' + esc(copyText(this.copy.noProducts, { query: queryLabel })) + '</p>'
        + (recoveryActions.length ? '<div class="mdv-search__recovery">' + recoveryActions.join('') + '</div>' : '');
    }
    this.elements.loadMore.innerHTML = this.nextCursor ? '<button type="button" data-load-more-button>' + esc(this.copy.viewMore) + '</button>' : '';
    this.applyPriceContextState();
    this.renderFilters(payload.facets || {});
    this.renderRibbons();
    this.root.querySelectorAll('[data-sort-select],[data-mobile-sort-select]').forEach(function select(element) { element.value = this.state.sort; }, this);
  };

  SearchView.prototype.filterMarkup = function filterMarkup(prefix, facets) {
    var definitions = this.payload && this.payload.facetDefinitions;
    return facetEntries(facets, true, definitions, this.pricingMode).map(function groupMarkup(group) {
      var open = this.openGroups.has(group.key);
      var options = group.options.map(function optionMarkup(option, index) {
        var checked = this.state.filters[group.key].has(option.id);
        var disabled = Boolean(option.disabled) && !checked;
        var id = prefix + '-' + group.key + '-' + index;
        var swatch = group.key === 'colour' ? '<span class="mdv-search__colour-swatch" style="--mdv-colour-fallback:' + esc(option.swatch || '#8b817d') + '" aria-hidden="true"></span>' : '<span class="mdv-search__checkbox" aria-hidden="true"></span>';
        return '<label class="mdv-search__filter-option' + (group.key === 'colour' ? ' mdv-search__filter-option--colour' : '') + (disabled ? ' is-disabled' : '') + '" for="' + esc(id) + '">'
          + '<input id="' + esc(id) + '" type="checkbox" value="' + esc(option.id) + '" data-filter-option data-filter-group="' + esc(group.key) + '"'
          + (checked ? ' checked' : '') + (disabled ? ' disabled' : '') + '>' + swatch
          + '<span class="mdv-search__filter-option-text"><span>' + esc(option.label || option.id) + '</span><span>(' + Number(option.optionCount != null ? option.optionCount : option.count || 0).toLocaleString(this.locale) + ')</span></span></label>';
      }, this).join('');
      return '<div class="mdv-search__filter-group' + (group.key === 'sale' ? ' mdv-search__filter-group--sale' : '') + '"><button class="mdv-search__filter-toggle" type="button" data-filter-toggle="' + esc(group.key) + '" aria-expanded="' + String(open) + '" aria-controls="' + esc(prefix + '-' + group.key + '-options') + '">'
        + '<span>' + esc(group.label) + '</span><span class="mdv-search__filter-symbol" aria-hidden="true"></span></button>'
        + '<div id="' + esc(prefix + '-' + group.key + '-options') + '" class="mdv-search__filter-options' + (group.key === 'colour' ? ' mdv-search__filter-options--colour' : '') + '"' + (open ? '' : ' hidden') + '>' + options + '</div></div>';
    }, this).join('');
  };
  SearchView.prototype.renderFilters = function renderFilters(facets) {
    if (this.nativeFallback) {
      var recovery = fallbackControlsMarkup(this.copy);
      this.elements.filterRail.innerHTML = recovery;
      this.elements.drawerBody.innerHTML = recovery;
      return;
    }
    this.elements.filterRail.innerHTML = this.filterMarkup(this.context + '-rail', facets);
    this.elements.drawerBody.innerHTML = this.filterMarkup(this.context + '-drawer', facets);
  };
  SearchView.prototype.activeEntries = function activeEntries() {
    return FACET_ORDER.flatMap(function facet(key) { return Array.from(this.state.filters[key]).map(function value(value) { return { key: key, value: value }; }); }, this);
  };
  SearchView.prototype.renderRibbons = function renderRibbons() {
    var entries = this.nativeFallback ? [] : this.activeEntries();
    var markup = entries.map(function chip(item) {
      var option = this.payload && this.payload.facets && (this.payload.facets[item.key] || []).find(function find(candidate) { return candidate.id === item.value; });
      var label = option ? option.label : item.value;
      return '<button class="mdv-search__filter-chip" type="button" data-remove-filter data-filter-group="' + esc(item.key) + '" data-filter-value="' + esc(item.value) + '" aria-label="' + esc(copyText(this.copy.removeFilter, { label: label })) + '"><span>' + esc(label) + '</span><span class="mdv-search__chip-close" aria-hidden="true">×</span></button>';
    }, this).join('') + (entries.length ? '<button class="mdv-search__clear-filters" type="button" data-clear-filters>' + esc(this.copy.clearAll) + '</button>' : '');
    this.root.querySelectorAll('[data-active-ribbon],[data-mobile-active-ribbon],[data-drawer-active-ribbon]').forEach(function ribbon(node) { node.innerHTML = markup; });
    this.root.querySelectorAll('[data-mobile-filter-count]').forEach(function count(node) { node.textContent = entries.length ? '(' + entries.length + ')' : ''; });
    var view = this.root.querySelector('[data-view-results]');
    if (view) {
      // In native-fallback mode `payload.total` is a capped suggest count (or 0),
      // so the drawer CTA drops the number rather than claim "View 10 results".
      view.textContent = this.nativeFallback
        ? this.copy.viewResultsGeneric
        : copyText(this.copy.viewResults, { count: Number((this.payload && this.payload.total) || 0).toLocaleString(this.locale) });
    }
  };

  SearchView.prototype.onClick = function onClick(event) {
    var swatchToggle = event.target.closest('[data-swatch-toggle]');
    if (swatchToggle) {
      event.preventDefault();
      var swatchGroup = swatchToggle.closest('[data-swatch-overflow-group]');
      var swatchOverflow = swatchGroup && swatchGroup.querySelector('[data-swatch-overflow]');
      if (!swatchGroup || !swatchOverflow) return;
      var expand = swatchToggle.getAttribute('aria-expanded') !== 'true';
      var hiddenCount = Number(swatchToggle.getAttribute('data-swatch-hidden') || swatchOverflow.children.length || 0);
      var swatchLabel = swatchGroup.getAttribute('aria-label') || '';
      swatchGroup.classList.toggle('is-expanded', expand);
      swatchOverflow.hidden = !expand;
      swatchToggle.setAttribute('aria-expanded', String(expand));
      swatchToggle.setAttribute('aria-label', expand ? swatchLabel : swatchLabel + ': +' + hiddenCount);
      swatchToggle.setAttribute('title', expand ? swatchLabel : swatchLabel + ': +' + hiddenCount);
      swatchToggle.textContent = expand ? '−' : '+' + hiddenCount;
      return;
    }
    var recent = event.target.closest('[data-recent-query]');
    if (recent) {
      event.preventDefault();
      this.setSearchContext(recent.dataset.recentGender || '', { deferSearch: true });
      this.setQuery(recent.dataset.recentQuery, true);
      return;
    }
    var term = event.target.closest('[data-search-term]');
    if (term) { event.preventDefault(); this.setQuery(term.dataset.searchTerm, true); return; }
    if (event.target.closest('[data-clear-recent]')) { try { root.localStorage.removeItem(this.recentKey()); } catch (_) {} this.renderRecent(); return; }
    var toggle = event.target.closest('[data-filter-toggle]');
    if (toggle) { var key = toggle.dataset.filterToggle; if (this.openGroups.has(key)) this.openGroups.delete(key); else this.openGroups.add(key); this.renderFilters(this.payload ? this.payload.facets : {}); return; }
    var chip = event.target.closest('[data-remove-filter]');
    if (chip) {
      this.state.filters[chip.dataset.filterGroup].delete(chip.dataset.filterValue);
      if (chip.dataset.filterGroup === 'gender') { this.contextChoice = ''; this.syncSearchContextControls(); }
      this.writeHistory(false);
      if (this.browsing()) this.runBrowse(); else this.runSearch(false);
      this.event('filter_remove', { facet: chip.dataset.filterGroup, value: chip.dataset.filterValue }); return;
    }
    if (event.target.closest('[data-clear-filters],[data-clear-all]')) {
      this.state.filters = emptyFilters(); this.contextChoice = ''; this.syncSearchContextControls(); this.writeHistory(false);
      if (this.browsing()) this.runBrowse(); else this.runSearch(false);
      return;
    }
    if (event.target.closest('[data-retry-search]')) { this.runSearch(false, false); return; }
    if (event.target.closest('[data-open-filters]')) { this.openFilters(); return; }
    if (event.target.closest('[data-close-filters],[data-view-results]')) { this.closeFilters(); return; }
    if (event.target.closest('[data-load-more-button]')) { this.runSearch(true); return; }
    var resultLink = event.target.closest('[data-mdv-result-link]');
    if (resultLink) {
      this.saveRecent(this.state.query);
      // product_click requires a query server-side, so browse-grid clicks are
      // not reported rather than sent as a guaranteed rejection.
      if (!this.browsing()) this.event('product_click', { query: this.state.query, resultId: resultLink.dataset.resultId });
      return;
    }
    if (event.target.closest('[data-search-close]') && this.context === 'page') { event.preventDefault(); root.location.assign('/'); }
  };
  SearchView.prototype.onChange = function onChange(event) {
    var contextOption = event.target.closest('[data-search-context-option]');
    if (contextOption) { this.setSearchContext(contextOption.value); return; }
    var option = event.target.closest('[data-filter-option]');
    if (option) {
      var facet = option.dataset.filterGroup;
      if (facet === 'gender') {
        var selected = canonicalSearchContext(option.value);
        this.state.filters.gender = option.checked && selected ? new Set([selected]) : new Set();
        this.contextChoice = option.checked ? selected : '';
        this.syncSearchContextControls();
      } else if (option.checked) this.state.filters[facet].add(option.value);
      else this.state.filters[facet].delete(option.value);
      this.writeHistory(false);
      if (this.browsing()) this.runBrowse(); else this.runSearch(false);
      this.event(option.checked ? 'filter_add' : 'filter_remove', { facet: facet, value: option.value });
      return;
    }
    if (event.target.matches('[data-sort-select],[data-mobile-sort-select]')) {
      if (this.pricingMode === 'price-free' && priceSort(event.target.value)) {
        event.target.value = this.state.sort;
        return;
      }
      this.state.sort = SEARCH_SORTS.indexOf(event.target.value) >= 0 ? event.target.value : 'relevance';
      this.writeHistory(false);
      if (this.browsing()) this.runBrowse(); else this.runSearch(false);
      this.event('sort', { sort: this.state.sort });
    }
  };
  SearchView.prototype.onInputKeydown = function onInputKeydown(event) {
    var options = Array.from(this.elements.suggestionList.querySelectorAll('[role="option"]'));
    if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && options.length) {
      event.preventDefault();
      var direction = event.key === 'ArrowDown' ? 1 : -1;
      this.activeSuggestion = this.activeSuggestion < 0 ? (direction > 0 ? 0 : options.length - 1) : (this.activeSuggestion + direction + options.length) % options.length;
      options.forEach(function selected(node, index) { node.setAttribute('aria-selected', String(index === this.activeSuggestion)); }, this);
      this.elements.input.setAttribute('aria-activedescendant', options[this.activeSuggestion].id);
    } else if (event.key === 'Enter') {
      event.preventDefault();
      var value = this.activeSuggestion >= 0 && options[this.activeSuggestion] ? options[this.activeSuggestion].dataset.searchTerm : this.elements.input.value;
      this.setQuery(value, true);
    } else if (event.key === 'Escape') {
      this.activeSuggestion = -1; this.elements.input.removeAttribute('aria-activedescendant'); this.elements.input.setAttribute('aria-expanded', 'false');
    }
  };
  SearchView.prototype.onRootKeydown = function onRootKeydown(event) {
    var contextOption = event.target.closest('[data-search-context-option]');
    if (contextOption) {
      var contextKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', ' ', 'Spacebar'];
      if (contextKeys.indexOf(event.key) >= 0) {
        event.preventDefault();
        var options = this.elements.contextOptions.filter(function enabled(option) { return !option.disabled; });
        var current = Math.max(0, options.indexOf(contextOption));
        var nextIndex = current;
        if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = options.length - 1;
        else if (event.key.indexOf('Arrow') === 0) {
          var forwards = event.key === 'ArrowRight' || event.key === 'ArrowDown';
          if ((event.key === 'ArrowLeft' || event.key === 'ArrowRight') && this.root.getAttribute('dir') === 'rtl') forwards = !forwards;
          nextIndex = (current + (forwards ? 1 : -1) + options.length) % options.length;
        }
        var nextOption = options[nextIndex];
        if (!nextOption) return;
        nextOption.focus();
        if (!nextOption.checked) {
          nextOption.checked = true;
          this.setSearchContext(nextOption.value);
        }
        return;
      }
    }
    var modal = this.root.closest('.search-desk-box');
    var drawerOpen = !this.elements.drawer.hidden;
    var modalOpen = this.context === 'modal' && modal && modal.classList.contains('active');
    if (event.key === 'Escape') {
      if (drawerOpen) { event.preventDefault(); this.closeFilters(); return; }
      if (modalOpen) { event.preventDefault(); this.root.querySelector('[data-search-close]').click(); this.modalOpener && this.modalOpener.focus(); }
      return;
    }
    if (event.key === 'Tab' && (drawerOpen || modalOpen)) {
      var container = drawerOpen ? this.elements.drawer : this.root;
      var focusable = Array.from(container.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])'))
        .filter(function visible(node) { return !node.hidden && node.getAttribute('aria-hidden') !== 'true' && node.getClientRects().length; });
      if (!focusable.length) return;
      var first = focusable[0]; var last = focusable[focusable.length - 1];
      if (!container.contains(document.activeElement)) { event.preventDefault(); first.focus(); }
      else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  };
  SearchView.prototype.commitToResultsPage = function commitToResultsPage() {
    if (this.context !== 'modal' || this.state.query.length < SEARCH_MIN_QUERY) return false;
    var action = this.elements.form && (this.elements.form.getAttribute('action') || this.elements.form.action);
    var destination = committedSearchUrl(root.MDVSearchApiV2, action, root.location.href, this.state);
    this.saveRecent(this.state.query);
    this.event('search_submitted', { query: this.state.query });
    if (this.api && typeof this.api.cancelAll === 'function') {
      try { this.api.cancelAll(); } catch (_) { /* navigation must still complete */ }
    }
    root.location.assign(destination);
    return true;
  };
  SearchView.prototype.setQuery = function setQuery(value, commit) {
    this.state.query = text(value); this.elements.input.value = this.state.query;
    this.searchSessionStarted = this.state.query.length > 0 || this.searchSessionStarted;
    if (commit && this.commitToResultsPage()) return;
    this.writeHistory(commit); this.renderShell(); this.runSuggest();
    if (this.state.query.length >= SEARCH_MIN_QUERY) { this.saveRecent(this.state.query); this.runSearch(false); this.event('search_submitted', { query: this.state.query }); }
    this.elements.input.focus({ preventScroll: true });
  };
  SearchView.prototype.resetSession = function resetSession() {
    // The regional themes close search from their existing global overlay/cart
    // handler. Keep this public controller contract so closing search cannot
    // interrupt the remaining mini-cart and page-overlay cleanup.
    this.requestGeneration += 1;
    if (this.api && typeof this.api.cancelAll === 'function') {
      try { this.api.cancelAll(); } catch (_) { /* closing search must still complete */ }
    }
    this.searchSessionStarted = false;
    this.state = { query: '', sort: 'relevance', filters: emptyFilters() };
    this.contextChoice = '';
    this.syncSearchContextControls();
    this.results = [];
    this.payload = null;
    this.executedQuery = '';
    this.nextCursor = null;
    this.activeSuggestion = -1;
    this.openGroups = new Set(['gender']);
    this.elements.input.value = '';
    this.elements.input.removeAttribute('aria-activedescendant');
    this.elements.suggestionList.innerHTML = '';
    this.elements.collections.innerHTML = '';
    this.elements.loading.hidden = true;
    this.elements.emptyResults.hidden = true;
    this.elements.emptyResults.textContent = '';
    this.elements.loadMore.innerHTML = '';
    this.elements.resultCount.textContent = '';
    this.elements.mobileResultCount.textContent = '';
    if (this.elements.searchNotice) this.elements.searchNotice.textContent = '';
    this.elements.status.textContent = '';
    this.writeHistory(false);
    this.renderShell();
    this.renderFilters({});
    this.renderRibbons();
    this.root.querySelectorAll('[data-sort-select],[data-mobile-sort-select]').forEach(function select(element) { element.value = 'relevance'; });
  };
  SearchView.prototype.openFilters = function openFilters() {
    var top = this.root.getBoundingClientRect().top || 0;
    this.root.style.setProperty('--mdv-filter-drawer-top', Math.max(0, top) + 'px');
    this.filterOpener = document.activeElement; this.root.classList.add('mdv-search--filters-open'); this.elements.topbar.setAttribute('aria-hidden', 'true'); this.elements.drawer.hidden = false;
    this.elements.drawerBody.scrollTop = 0; document.body.classList.add('mdv-search-filter-open');
    var close = this.elements.drawer.querySelector('[data-close-filters]'); if (close) close.focus();
  };
  SearchView.prototype.closeFilters = function closeFilters() {
    if (this.elements.drawer.hidden) return;
    this.elements.drawer.hidden = true; this.root.classList.remove('mdv-search--filters-open'); this.elements.topbar.removeAttribute('aria-hidden'); document.body.classList.remove('mdv-search-filter-open');
    var target = this.filterOpener && this.filterOpener.isConnected ? this.filterOpener : this.root.querySelector('[data-open-filters]');
    if (target) target.focus({ preventScroll: true }); this.filterOpener = null;
  };
  SearchView.prototype.event = function event(type, details) {
    if (!this.api) return;
    this.api.sendEvent(Object.assign({ type: type, query: this.state.query }, details || {})).catch(function ignore() {});
  };

  function start() {
    if (!root.document || !root.MDVSearchApiV2) return;
    root.document.querySelectorAll('[data-mdv-search]').forEach(function each(element) {
      if (element.mdvSearch) return;
      var view = new SearchView(element); element.mdvSearch = view; view.init();
    });
  }
  if (root.document) {
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  }
  return Object.freeze({ formatMoney: formatMoney, productHref: productHref, salePriceMarkup: salePriceMarkup, containedSwatchCount: containedSwatchCount, cardMarkup: cardMarkup, facetEntries: facetEntries, canonicalSearchContext: canonicalSearchContext, searchContextValue: searchContextValue, normalizeRecentEntry: normalizeRecentEntry, recentEntryForState: recentEntryForState, committedSearchUrl: committedSearchUrl, copyFor: copyFor, copyText: copyText, fallbackControlsMarkup: fallbackControlsMarkup, directionForLocale: directionForLocale, suggestionLimitForRuntime: suggestionLimitForRuntime, shellState: shellState, canonicalPopularCollections: canonicalPopularCollections, configuredPopularImage: configuredPopularImage, popularImageLoading: popularImageLoading, withoutMoney: withoutMoney, withoutPriceControls: withoutPriceControls, withoutUnsupportedControls: withoutUnsupportedControls });
}));
